<template>
  <div class="home-page">
    <!-- 头部导航组件 -->
    <HeaderNav />

    <!-- 统一的顶部装饰和轮播图 -->
    <div class="box_1-spacer flex-col"></div>
    <div class="box_2 flex-col"></div>
    <div class="banner-wrapper">
      <van-swipe
        class="banner-swipe"
        :autoplay="5000"
        indicator-color="#fff"
        :show-indicators="bannerList.length > 1"
      >
        <van-swipe-item
          v-for="item in bannerList"
          :key="item.id"
        >
          <img
            class="banner-img"
            :src="getImageUrl(item.img)"
            :alt="item.title || '首页轮播图'"
            referrerpolicy="no-referrer"
          />
        </van-swipe-item>
      </van-swipe>
    </div>
    <!-- 公告滚动带和Logo -->
    <div class="notice-bar" v-if="siteConfig?.config?.notice">
      <div class="notice-content">
        <img class="banner-logo" src="./assets/img/33bcaefd8058d446c0c4a764f9cc1c58.png" alt="Logo" referrerpolicy="no-referrer" />
        <div class="notice-left">
          <span class="notice-label">公告：</span>
          <div class="notice-text-wrapper">
            <div class="notice-text" :style="{ animationDuration: noticeAnimationDuration }">
              {{ siteConfig.config.notice }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 第二层：龙真墓地介绍 -->
    <div class="section-intro container">
      <!-- 左侧：标题组 -->
      <div class="intro-left">
        <div class="vertical-title-group">
          <span class="en-title">LONGZHEN CEMETERY</span>
          <div class="title-separator"></div>
          <span class="cn-title">天堂福地</span>
        </div>
      </div>

      <!-- 右侧：内容区 -->
      <div class="intro-right">
        <div class="intro-text-wrapper" v-html="siteConfig?.config?.['天堂福地'] || ''">
        </div>
      </div>
    </div>

    <!-- 第三层：园林景观 -->

    <!-- Section 3: Landscape (园林景观) -->
    <div class="section-landscape container" :class="{ 'expanded': showAllGardens }">
      <div class="section-header">
        <div class="header-main">
          <img class="header-deco left" src="./assets/img/b5ab3c1e061c0bf1f0a4f27363886802.png" alt="deco" />
          <h2 class="header-title">园林景观</h2>
          <img class="header-deco right" src="./assets/img/31e0fdcf6093dad60f60aa15ae0f358f.png" alt="deco" />
        </div>
        <div class="header-sub">GARDEN LANDSCAPE</div>
      </div>

      <div class="landscape-grid">
        <div v-for="item in displayGardenList" :key="item.id" class="landscape-card">
          <div class="card-image-box">
             <img v-if="item.cover" :src="getImageUrl(item.cover)" :alt="item.title" class="card-img" referrerpolicy="no-referrer" />
          </div>
          <div class="card-title">{{ item.title }}</div>
        </div>
      </div>

      <div class="section-footer">
        <img 
          class="expand-btn" 
          :class="{ 'rotated': showAllGardens }"
          src="./assets/img/3013d97e57b71507e42cce1e99f8ee0d.png" 
          @click="toggleShowAllGardens"
          alt="Expand"
        />
      </div>
    </div>
    <!-- Section 4: Tomb Types (墓型展示) -->
    <div class="section-tomb container">
      <div class="section-header">
        <div class="header-main">
          <img class="header-deco left" src="./assets/img/b5ab3c1e061c0bf1f0a4f27363886802.png" alt="deco" />
          <h2 class="header-title">墓型展示</h2>
          <img class="header-deco right" src="./assets/img/31e0fdcf6093dad60f60aa15ae0f358f.png" alt="deco" />
        </div>
        <div class="header-sub">TOMB TYPE DISPLAY</div>
      </div>

      <div class="tomb-intro">
        <div class="intro-card-img">
          <img src="./assets/img/b8d1de1429bf7e0ab1edbd874da9888e.png" alt="intro" />
        </div>
        <div class="intro-card-text">
          <h3>一碑一故事，一墓一人生的高端艺术墓区</h3>
          <p>A high-end art cemetery where each tombstone tells a story and each grave represents a life.</p>
        </div>
      </div>

      <!-- Tomb List -->
      <div class="landscape-grid" v-if="displayShapesList.length > 0">
        <div 
          v-for="item in displayShapesList" 
          :key="item.id"
          class="landscape-card"
        >
          <div class="card-image-box">
            <img
              v-if="item.cover"
              :src="getImageUrl(item.cover)"
              :alt="item.title"
              class="card-img"
              referrerpolicy="no-referrer"
            />
          </div>
          <div class="card-title">{{ item.title }}</div>
        </div>
      </div>

      <div class="section-footer">
        <img 
          class="expand-btn" 
          src="./assets/img/3013d97e57b71507e42cce1e99f8ee0d.png" 
          @click="goToTombDisplay"
          alt="Expand"
        />
      </div>
    </div>
    <!-- 第五层：在线购墓 -->
    <!-- Section 5: Online Purchase (在线购墓) -->
    <div class="section-online-purchase container">
      <div class="online-card">
        <div class="online-left">
           <div class="online-en">ONLINE PURCHASE OF BURIAL PLOTS</div>
           <div class="online-sep"></div>
           <div class="online-cn">在线购墓</div>
        </div>
        <div class="online-right">
          <img src="/files/images/yiersan.jpg" alt="Online" class="online-img" referrerpolicy="no-referrer" />
          <div class="online-btn" @click="goToCemeteryList">
            <span></span>
          </div>
        </div>
      </div>
    </div>
    <!-- 第六层：人文纪念 -->
    <!-- Section 6: Humanistic Memorial (人文纪念) -->
    <div class="section-memorial" style="width: 100%;">
      <div class="memorial-content-wrapper">
        <!-- Left Side: Header, Image 1, Desc -->
        <div class="mem-left">
           <!-- <div class="mem-header">
             <span class="mem-cn">人文纪念</span>
             <div class="mem-sep"></div>
             <span class="mem-en">HUMANISTIC COMMEMORATION</span>
           </div> -->
           
           <div class="mem-body" >
             <img src="/files/images/renwen2.jpg" class="mem-img-small" referrerpolicy="no-referrer" />
             <div class="mem-info">
                <h4 class="mem-sub-cn">祭扫平台</h4>
                <div class="mem-sub-en">TOMB SWEEPING PLATFORM</div>
                <div class="mem-sub-sep"></div>
                <p class="mem-desc">可在线选择墓碑进行祭扫<br /><br />选择祭奠方式：<br />包括上香、点烛、献花、祭品、装饰、扫墓、留言</p>
                <div class="mem-btn-wrapper" @click="goToRememberList">
                   <img src="./assets/img/a3dfaed9873930d3f6582a8e4a038360.png" class="mem-arrow-btn" referrerpolicy="no-referrer" />
                </div>
             </div>
           </div>
        </div>
        
        <!-- Right Side: Large Image -->
        <div class="mem-right">
           <img src="/files/images/renwen.jpg" class="mem-img-large" referrerpolicy="no-referrer" />
        </div>
      </div>
    </div>

    <!-- Section 7: News (新闻资讯) -->
    <div class="section-news container" v-if="newsList.length > 0" style="margin-top: 100px;width:80%;margin:0 auto">
      <div class="news-layout" style="margin-top: 100px;">
        <!-- <div class="news-header">
          <div class="news-header-en">NEWS AND INFORMATION</div>
          <div class="news-header-sep"></div>
          <div class="news-header-cn">新闻资讯</div>
        </div> -->
         <div class="online-left">
           <div class="online-en">NEWS AND INFORMATION</div>
           <div class="online-sep"></div>
           <div class="online-cn">新闻资讯</div>
        </div>
        
        <div class="news-grid-wrapper">
          <!-- Left Column News -->
          <div class="news-column" v-if="leftNewsList.length > 0">
            <div 
              v-for="item in leftNewsList" 
              :key="item.id"
              class="news-card" 
              @click="goToNewsDetail(item.id)"
            >
              <div class="news-date-box">
                <span class="news-day">{{ formatDay(item.created_at) }}</span>
                <div class="news-date-sep"></div>
                <span class="news-month">{{ formatMonthYear(item.created_at) }}</span>
              </div>
              <div class="news-content">
                <div class="news-title">{{ item.title }}</div>
                <div class="news-desc" >{{ item.desc || item.title }}</div>
              </div>
            </div>
          </div>
          
          <!-- Right Column News -->
          <div class="news-column" v-if="rightNewsList.length > 0" >
            <div 
              v-for="item in rightNewsList" 
              :key="item.id"
              class="news-card"
              @click="goToNewsDetail(item.id)"
            >
              <div class="news-date-box">
                <span class="news-day">{{ formatDay(item.created_at) }}</span>
                <div class="news-date-sep"></div>
                <span class="news-month">{{ formatMonthYear(item.created_at) }}</span>
              </div>
              <div class="news-content" style="width: 230px;"> 
                <div class="news-title">{{ item.title }}</div>
                <div class="news-desc" >{{ item.desc || item.title }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="news-footer" style="text-align: center; margin-top: 30px;">
         <!-- <div class="view-all-btn" @click="goToNewsList">查看全部</div> -->
           <div class="section-footer">
        <img 
          class="expand-btn" 
          :class="{ 'rotated': showAllGardens }"
          src="./assets/img/3013d97e57b71507e42cce1e99f8ee0d.png" 
         @click="goToNewsList"
          alt="Expand"
        />
      </div>
      </div>
    </div>
    <!-- 联系我们部分 - 独立整体 -->
    <ContactUsSection />
  </div>
</template>
<script>
import HeaderNav from '@/components/HeaderNav.vue';
import ContactUsSection from '@/components/ContactUsSection.vue';
import { getGardens, getProducts, getShapeList, getSiteConfig, getBanner } from '@/api/home';
import { getNewsList } from '@/api/news';
import { getImageUrl } from '@/config/api';

export default {
  components: {
    HeaderNav,
    ContactUsSection
  },
  data() {
    return {
      constants: {},
      newsList: [],
      loading: false,
      // 顶部轮播图列表
      bannerList: [],
      // 园林景观列表（从接口获取）
      gardenList: [],
      showAllGardens: false,
      // 购墓列表（从接口获取）
      cemeteryList: [],
      // 墓葬展示列表（从接口获取）
      shapesList: [],
      // 所有分类列表（用于查找 ID）
      allCategories: [],
      // 选中的墓葬分类
      selectedShapeCategory: null,
      // 网站配置
      siteConfig: null
    };
  },
  computed: {
    // 左侧新闻列表（第一列，3条）
    leftNewsList() {
      return this.newsList.slice(0, 3);
    },
    // 右侧新闻列表（第二列，3条）
    rightNewsList() {
      return this.newsList.slice(3, 6);
    },
    // 显示的园林景观列表（默认显示前5个，点击查看全部后显示所有）
    displayGardenList() {
      if (this.showAllGardens) {
        return this.gardenList;
      }
      return this.gardenList.slice(0, 6);
    },
    // 显示的购墓列表（显示前4个）
    displayCemeteryList() {
      return this.cemeteryList.slice(0, 4);
    },
    // 显示的墓葬展示列表（只显示前6个）
    displayShapesList() {
      if (!this.shapesList || !Array.isArray(this.shapesList)) {
        return [];
      }
      // 只返回前6个
      return this.shapesList.slice(0, 6);
    },
    // 公告滚动动画时长（根据文本长度计算）
    noticeAnimationDuration() {
      if (!this.siteConfig?.config?.notice) return '20s';
      const textLength = this.siteConfig.config.notice.length;
      // 根据文本长度计算动画时长，大约每10个字符1秒
      const duration = Math.max(15, textLength * 0.1);
      return `${duration}s`;
    }
  },
  mounted() {
    this.fetchBanner();
    this.fetchNews();
    this.fetchGardens();
    this.fetchCemeteryList();
    this.fetchShapes();
    this.fetchSiteConfig();
  },
  methods: {
    // 获取首页轮播图
    async fetchBanner() {
      try {
        const res = await getBanner();
        if (res.code === 0 && res.data && res.data.list) {
          this.bannerList = res.data.list;
        }
      } catch (error) {
        console.error('获取轮播图失败:', error);
      }
    },
    // 获取新闻列表
    async fetchNews() {
      try {
        const res = await getNewsList();
        if (res.code === 0 && res.data && res.data.list) {
          this.newsList = res.data.list;
        }
      } catch (error) {
        console.error('获取新闻列表失败:', error);
      }
    },
    // 获取园林景观列表
    async fetchGardens() {
      try {
        const res = await getGardens();
        if (res.code === 0 && res.data && res.data.list) {
          this.gardenList = res.data.list;
        }
      } catch (error) {
        console.error('获取园林景观列表失败:', error);
      }
    },
    // 获取购墓列表（产品列表）
    async fetchCemeteryList() {
      try {
        const res = await getProducts();
        if (res.code === 0 && res.data && res.data.list) {
          this.cemeteryList = res.data.list;
        }
      } catch (error) {
        console.error('获取购墓列表失败:', error);
      }
    },
    // 获取墓葬展示列表
    async fetchShapes() {
      try {
        const res = await getShapeList();
        console.log('fetchShapes 响应:', res);
        if (res.code === 0 && res.data) {
          // 新接口返回的数据结构: { data: { list: [...] } }
          if (res.data.list && Array.isArray(res.data.list)) {
            this.shapesList = res.data.list;
          } else if (Array.isArray(res.data)) {
            this.shapesList = res.data;
          }
          console.log('更新 shapesList:', this.shapesList);
        }
      } catch (error) {
        console.error('获取墓葬展示列表失败:', error);
      }
    },
    // 获取网站配置
    async fetchSiteConfig() {
      try {
        const res = await getSiteConfig();
        if (res.code === 0 && res.data && res.data.config) {
          this.siteConfig = res.data;
        }
      } catch (error) {
        console.error('获取网站配置失败:', error);
      }
    },
    // 选择墓葬分类
    selectShapeCategory(category) {
      this.selectedShapeCategory = category;
      // 如果选择了具体分类，需要找到对应的 cate_id
      if (category !== null) {
        // 优先从 allCategories 中查找，如果没有则从 shapesList 中查找
        let selectedCat = this.allCategories.find(cat => cat.title === category);
        if (!selectedCat && this.shapesList && Array.isArray(this.shapesList) && this.shapesList.length > 0) {
          selectedCat = this.shapesList.find(cat => cat.title === category);
        }
        
        if (selectedCat && selectedCat.id) {
          // 传入对应的 cate_id
          console.log('选择分类:', category, '找到分类:', selectedCat, 'ID:', selectedCat.id);
          this.fetchShapes();
        } else {
          console.warn('未找到分类:', category);
          console.warn('allCategories:', this.allCategories);
          console.warn('shapesList:', this.shapesList);
          // 如果找不到，尝试从 allCategories 中打印所有可用的分类名称
          if (this.allCategories.length > 0) {
            console.warn('可用的分类名称:', this.allCategories.map(cat => cat.title));
          }
        }
      } else {
        // 选择"全部"时，不传参数
        console.log('选择全部，不传参数');
        this.fetchShapes();
      }
    },
    // 切换显示全部园林景观
    toggleShowAllGardens() {
      this.showAllGardens = !this.showAllGardens;
    },
    // 跳转到墓型展示页面
    goToTombDisplay() {
      this.$router.push('/lanhu_muxingzhanshi');
    },
    // 获取园林景观项的样式（统一方法，支持多行）
    getGardenItemStyle(index) {
      // 第一行的位置映射（相对于 section_8）
      // 列0: margin-top 205px, margin-left -57px (block_14)
      // 列1: margin-top 205px, margin-left 40px (block_15)
      // 列2: margin-top 118px, margin-left 40px (block_17)
      // 列3: margin-top 205px, margin-left -68px (box_32)
      // 列4: margin-top 205px, margin-left 180px (box_34-wrapper)
      const firstRowPositions = [
        { top: 205, left: -57 },   // 列0
        { top: 205, left: 40 },     // 列1
        { top: 118, left: 40 },     // 列2
        { top: 205, left: -68 },    // 列3
        { top: 205, left: 180 }     // 列4
      ];
      
      // 计算行号和列号
      const row = Math.floor(index / 5);
      const col = index % 5;
      
      // 获取第一行对应列的位置
      const firstRowPos = firstRowPositions[col];
      
      // 计算当前项的位置
      // 第一行高度 296px，每行间距相同
      const marginTop = firstRowPos.top + row * 296;
      const marginLeft = firstRowPos.left;
      
      return {
        marginTop: `${marginTop}px`,
        marginLeft: `${marginLeft}px`
      };
    },
    // 获取按钮的 margin-top（根据显示的行数动态计算）
    getButtonMarginTop() {
      if (!this.showAllGardens) {
        return {};
      }
      // 计算需要下移的距离：每行高度 296px + 底部间距 30px = 326px
      // 从第7个开始（索引6），所以需要计算有多少行
      const extraItems = this.displayGardenList.length - 6;
      if (extraItems <= 0) {
        return {};
      }
      const extraRows = Math.ceil(extraItems / 6);
      // 每行高度 296px + 底部间距 30px = 326px
      const marginTop = extraRows * 326;
      return {
        marginTop: `${marginTop}px`
      };
    },
    // 格式化日期 - 获取日
    formatDay(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      const day = date.getDate();
      return day < 10 ? '0' + day : day.toString();
    },
    // 格式化日期 - 获取月-年
    formatMonthYear(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      return `${year}-${month < 10 ? '0' + month : month}`;
    },
    // 跳转到新闻列表
    goToNewsList() {
      this.$router.push('/news');
    },
    // 跳转到新闻详情
    goToNewsDetail(newsId) {
      this.$router.push(`/news/${newsId}`);
    },
    // 跳转到人文纪念列表（在线祭奠页面）
    goToRememberList() {
      this.$router.push('/lanhu_zaixianjidian');
    },
    // 跳转到购墓列表页面
    goToCemeteryList() {
      this.$router.push('/lanhu_zaixiangoumu');
    },
    // 跳转到产品详情页
    goToProductDetail(productId) {
      if (productId) {
        this.$router.push({
          path: `/product/${productId}`,
          query: {
            product_id: productId
          }
        });
      }
    },
    // 获取购墓项的class（根据索引返回对应的class）
    getCemeteryItemClass(index) {
      const classes = [
        'group_32 flex-col',
        'group_33 flex-col',
        'group_34 flex-col',
        'group_35 flex-col'
      ];
      return classes[index] || 'group_32 flex-col';
    },
    // 获取购墓图片的class
    getCemeteryImageClass(index) {
      const classes = [
        'section_10 flex-col',
        'box_35 flex-col',
        'box_37 flex-col',
        'block_20 flex-col'
      ];
      return classes[index] || 'section_10 flex-col';
    },
    // 获取购墓标题的class
    getCemeteryTitleClass(index) {
      const classes = [
        'text_71',
        'text_75',
        'text_79',
        'text_83'
      ];
      return classes[index] || 'text_71';
    },
    // 获取购墓价格的class
    getCemeteryPriceClass(index) {
      const classes = [
        'section_11 flex-row justify-between',
        'box_36 flex-row justify-between',
        'box_38 flex-row justify-between',
        'block_21 flex-row justify-between'
      ];
      return classes[index] || 'section_11 flex-row justify-between';
    },
    // 获取购墓价格标签的class
    getCemeteryPriceLabelClass(index) {
      const classes = [
        'text_72',
        'text_76',
        'text_80',
        'text_84'
      ];
      return classes[index] || 'text_72';
    },
    // 获取购墓价格包装器的class
    getCemeteryPriceWrapperClass(index) {
      const classes = [
        'text-wrapper_14',
        'text-wrapper_15',
        'text-wrapper_16',
        'text-wrapper_17'
      ];
      return classes[index] || 'text-wrapper_14';
    },
    // 获取购墓价格符号的class
    getCemeteryPriceSymbolClass(index) {
      const classes = [
        'text_73',
        'text_77',
        'text_81',
        'text_85'
      ];
      return classes[index] || 'text_73';
    },
    // 获取购墓价格值的class
    getCemeteryPriceValueClass(index) {
      const classes = [
        'text_74',
        'text_78',
        'text_82',
        'text_86'
      ];
      return classes[index] || 'text_74';
    },
    // 获取购墓标题（显示产品标题）
    getCemeteryTitle(item) {
      if (!item || !item.title) {
        return '暂无数据';
      }
      return item.title;
    },
    // 获取购墓价格
    getCemeteryPrice(item) {
      if (!item || !item.price) {
        return '无参考价';
      }
      // 格式化价格，保留两位小数
      const price = parseFloat(item.price);
      if (isNaN(price)) {
        return '无参考价';
      }
      return price.toFixed(2);
    },
    // 拼接图片URL
    getImageUrl(imgPath) {
      return getImageUrl(imgPath);
    }
  }
};
</script>
/* <style scoped lang="css" src="./assets/index.css" /> Removed legacy CSS */
<style>
/* 全局隐藏水平滚动条 */
html, body {
  overflow-x: hidden !important;
}

</style>
<style scoped>
/* ==================================
   Base Layout & Reset
   ================================== */
.home-page {
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  overflow-x: hidden;
  position: relative;
  background-color: #fff;
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  box-sizing: border-box;
}

/* ==================================
   Section 1: Banner Area
   ================================== */
.box_1-spacer {
  background-color: rgba(255, 255, 255, 1) !important;
  width: 100% !important;
  max-width: 1920px !important;
  height: auto !important;
  min-height: 100px !important;
  margin: 0 auto !important;
  box-sizing: border-box !important;
}

.box_2 {
  background-color: rgba(0, 149, 151, 1) !important;
  width: 100% !important;
  max-width: 36px !important;
  height: 4px !important;
  margin: 50px auto 0 !important;
  box-sizing: border-box !important;
}

.banner-wrapper {
  width: 100% !important;
  max-width: 1918px !important;
  height: auto !important;
  min-height: 398px !important;
  margin: -53px auto 0 !important;
  overflow: hidden !important;
  box-sizing: border-box !important;
}

.banner-swipe {
  width: 100%;
  height: 100%;
}

.banner-img {
  width: 100% !important;
  max-width: 1918px !important;
  height: auto !important;
  min-height: 398px !important;
  margin: 0 auto !important;
  object-fit: cover !important;
  display: block !important;
  box-sizing: border-box !important;
}


/* 公告滚动带 */
.notice-bar {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  background-color: #f5f5f5;
  border-top: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
  padding: 12px 0;
  overflow: hidden;
  box-sizing: border-box;
}

.notice-content {
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  box-sizing: border-box;
  gap: 20px;
}

.banner-logo {
  flex-shrink: 0;
  width: 200px;
  height: auto;
  max-height: 40px;
  object-fit: contain;
}

.notice-left {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  overflow: hidden;
}

.notice-label {
  flex-shrink: 0;
  font-size: 14px;
  font-weight: bold;
  color: #8c3000;
  margin-right: 12px;
  line-height: 1.5;
  display: flex;
  align-items: center;
}

.notice-text-wrapper {
  flex: 1;
  overflow: hidden;
  position: relative;
  min-width: 0;
  display: flex;
  align-items: center;
}

.notice-text {
  white-space: nowrap;
  animation: notice-scroll linear infinite;
  font-size: 14px;
  color: #666;
  display: inline-block;
  line-height: 1.5;
  vertical-align: middle;
}

@keyframes notice-scroll {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(-100%);
  }
}

/* Mobile Banner Adjustments */
@media (max-width: 768px) {
  .box_1-spacer {
    min-height: 80px !important;
  }

  .box_2 {
    margin: 30px auto 0 !important;
  }

  .banner-wrapper {
    margin: -40px auto 0 !important;
    min-height: 300px !important;
  }
  
  .banner-img {
    min-height: 300px !important;
  }
  
  .notice-bar {
    padding: 10px 0;
  }
  
  .notice-bar {
    max-width: 100%;
  }
  
  .notice-content {
    padding: 0 15px;
    gap: 10px;
  }
  
  .banner-logo {
    width: 120px;
    height: auto;
    max-height: 30px;
  }
  
  .notice-left {
    flex: 1;
    min-width: 0;
  }
  
  .notice-label {
    font-size: 12px;
    margin-right: 8px;
  }
  
  .notice-text {
    font-size: 12px;
  }
}

/* ==================================
   Section 2: Intro Area (龙真墓地)
   ================================== */
.section-intro {
  display: flex;
  flex-direction: row;
  margin-top: 60px;
  margin-bottom: 60px;
  align-items: flex-start;
  gap: 40px;
}

/* Left: Vertical Titles */
.intro-left {
  flex: 0 0 auto;
  padding-top: 20px;
}

.vertical-title-group {
  display: flex;
  /* flex-direction: column; */
  align-items: center;
}

.en-title {
  writing-mode: vertical-rl;
  text-orientation: mixed;
  font-family: BookmanOldStyle;
  color: #5c5c5c;
  font-size: 15px;
  letter-spacing: 2px;
  height: 220px;
}

.title-separator {
  width: 2px;
  height: 80px;
  background-color: #956d53;
  margin: 10px 0;
}

.cn-title {
  writing-mode: vertical-rl;
  text-orientation: mixed;
  font-family: STKaitiSC-Bold;
  font-weight: 500;
  font-size: 30px;
  color: #000;
  letter-spacing: 5px;
  height: 200px;
}

/* Right: Content */
.intro-right {
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
  padding: 20px 40px 40px 40px;
  min-height: 360px;
}

.intro-text-wrapper {
  width: 100%;
  max-width: 100%;
  z-index: 2; /* Text above decorative elements */
}

.intro-subtitle {
  font-family: STKaitiSC-Black;
  font-size: 18px;
  color: #8c3000;
  margin-bottom: 20px;
}

.intro-title {
  font-family: STKaitiSC-Black;
  font-size: 24px;
  color: #ffffff;
  margin-bottom: 20px;
}

.intro-desc {
  font-family: AlibabaPuHuiTi_2_55_Regular;
  font-size: 14px;
  color: #ffffff;
  line-height: 1.8;
  max-width: 600px;
  text-align: justify;
}

/* Overlapping Image */
.intro-image-box {
  width: 440px;
  height: 280px;
  background: url(/files/images/zhutu.jpg) no-repeat center center;
  background-size: cover;
  position: absolute;
  right: -50px;
  top: 50px;
  box-shadow: 0 10px 20px rgba(0,0,0,0.1);
  z-index: 3;
}

/* Mobile Adaptation for Intro */
@media (max-width: 992px) {
  .section-intro {
    flex-direction: column;
    align-items: center;
    margin-top: 30px;
    gap: 20px;
  }

  /* Flatten vertical titles for mobile */
  .intro-left {
    width: 100%;
    padding-top: 0;
  }

  .vertical-title-group {
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 15px;
  }

  .en-title, .cn-title {
    writing-mode: horizontal-tb;
    height: auto;
    letter-spacing: 0;
  }

  .en-title {
    order: 2;
    font-size: 12px;
  }

  .cn-title {
    order: 1;
    font-size: 24px;
  }

  .title-separator {
    width: 40px;
    height: 2px;
    order: 3;
    display: none; /* Hide separator on mobile */
  }

  /* Adjust Content Area */
  .intro-right {
    flex-direction: column;
    padding: 30px 20px;
    width: 100%;
    box-sizing: border-box;
  }

  .intro-image-box {
    position: relative;
    width: 100%;
    height: 200px;
    right: auto;
    top: auto;
    margin-top: 20px;
  }
}
.footer-wrapper {
  margin: 0 auto;
}

/* 首页图片样式 */
.banner-wrapper {
  width: 100%;
  max-width: 1918px;
  height: auto;
  min-height: 400px;
  margin: -120px auto 0;
  position: relative;
  overflow: hidden;
}

.banner-wrapper .image_1 {
  width: 100%;
  height: auto;
  min-height: 400px;
  object-fit: cover;
  display: block;
}

/* 新闻列表样式 - 覆盖原有CSS固定宽度 */
.news-item {
  cursor: pointer;
  transition: opacity 0.3s;
}

.news-item:hover {
  opacity: 0.8;
}

/* 修复文字显示不完整的问题 */
.text-wrapper_7,
.text-wrapper_8,
.text-wrapper_9,
.text-wrapper_10 {
  flex: 1 !important;
  min-width: 0 !important;
  width: auto !important;
  max-width: none !important;
}

.text_33,
.text_37,
.text_41,
.text_45 {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  display: block !important;
  width: 100% !important;
  max-width: 100% !important;
  height: auto !important;
}

.text_34,
.text_38,
.text_42,
.text_46 {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  display: -webkit-box !important;
  -webkit-line-clamp: 2 !important;
  -webkit-box-orient: vertical !important;
  line-height: 1.4 !important;
  max-height: 2.8em !important;
  width: 100% !important;
  max-width: 100% !important;
  height: auto !important;
}

/* text-wrapper_11 的基础样式已移到下面，这里只保留 hover 效果 */
.text-wrapper_11:hover {
  opacity: 0.8;
}

/* 修复新闻资讯区域布局和文字遮挡问题 */
.box_11 {
  display: flex !important;
  align-items: flex-start !important;
  position: relative !important;
  z-index: 1 !important;
}

.text_29 {
  width: auto !important;
  max-width: none !important;
  height: auto !important;
  writing-mode: vertical-rl !important;
  text-orientation: mixed !important;
  overflow: visible !important;
  letter-spacing: 3px !important;
  margin-right: 15px !important;
  white-space: nowrap !important;
  position: relative !important;
  z-index: 2 !important;
}

.text_30 {
  width: auto !important;
  max-width: none !important;
  height: auto !important;
  writing-mode: vertical-rl !important;
  text-orientation: mixed !important;
  overflow: visible !important;
  margin: 0 0 0 25px !important;
  letter-spacing: 10px !important;
  white-space: nowrap !important;
  position: relative !important;
  z-index: 2 !important;
}

/* 隐藏首页的下划线元素，统一使用 HeaderNav 组件的下划线 */
.group_2 {
  display: none !important;
}

/* 恢复 block_8 的原始样式 */
.block_8 {
  background-color: rgba(255, 255, 255, 1) !important;
  height: auto !important; /* 完全自适应高度 */
  margin-top: 100px !important; /* 添加顶部间距，确保不与 block_22 重叠 */
  width: 100% !important; /* 改为100%宽度，确保能够容纳所有内容 */
  max-width: 1920px !important; /* 最大宽度限制 */
  position: relative !important;
  margin-left: auto !important;
  margin-right: auto !important;
  clear: both !important;
  display: block !important;
  overflow: visible !important; /* 允许内容显示，确保 group_28 能够完整显示 */
  padding-bottom: 100px !important; /* 减少 padding-bottom，只保留少量间距确保 group_28 完整显示 */
}

/* 使用伪元素精确控制 block_8 的高度，确保包含 group_28 */
.block_8::after {
  content: '';
  display: block;
  height: 0; /* 不设置固定高度，让流式内容自然决定高度 */
  visibility: hidden;
  pointer-events: none;
}

/* 新闻资讯部分 - 覆盖旧样式 */
.news-header-row-1 .box_11 {
  width: auto !important;
  height: auto !important;
  margin: 0 !important;
}

/* 新闻资讯部分 - 标题样式（在 news-header-left 中） */
.news-header-left .text_29 {
  width: auto !important;
  height: auto !important;
  writing-mode: initial !important;
  text-orientation: initial !important;
  overflow-wrap: break-word !important;
  color: rgba(92, 92, 92, 1) !important;
  font-size: 16px !important;
  font-family: BookmanOldStyle !important;
  font-weight: normal !important;
  text-align: left !important;
  line-height: 16px !important;
  letter-spacing: 0 !important;
  margin: 0 0 10px 0 !important;
  position: static !important;
  z-index: auto !important;
}

.news-header-left .text_30 {
  width: auto !important;
  height: auto !important;
  writing-mode: initial !important;
  text-orientation: initial !important;
  overflow-wrap: break-word !important;
  color: rgba(0, 0, 0, 1) !important;
  font-size: 48px !important;
  font-family: STKaitiSC-Bold !important;
  font-weight: 700 !important;
  text-align: left !important;
  line-height: 48px !important;
  letter-spacing: 0 !important;
  margin: 0 !important;
  position: static !important;
  z-index: auto !important;
}

/* 新闻列表列中的 section_1 样式 */
.news-list-column .section_1 {
  width: 100% !important;
  height: auto !important;
  margin: 0 !important;
}

/* 恢复 group_21 的原始样式 */
.group_21 {
  background-color: rgba(255, 255, 255, 1) !important;
  width: 504px !important;
  height: auto !important;
  min-height: 112px !important;
  border: 1px solid rgba(222, 222, 222, 1) !important;
  margin-top: -120px !important;
}

/* 恢复 section_2 的原始样式 */
.section_2 {
  width: 72px !important;
  height: 67px !important;
  margin: 23px 0 0 16px !important;
}

.text_31 {
  width: 38px !important;
  height: 26px !important;
  overflow-wrap: break-word !important;
  color: rgba(0, 0, 0, 1) !important;
  font-size: 32px !important;
  font-family: SourceHanSansCN-Bold !important;
  font-weight: 700 !important;
  text-align: center !important;
  white-space: nowrap !important;
  line-height: 32px !important;
  margin-left: 17px !important;
}

.section_3 {
  background-color: rgba(0, 0, 0, 1) !important;
  width: 72px !important;
  height: 1px !important;
  margin-top: 11px !important;
}

.text_32 {
  width: 64px !important;
  height: 13px !important;
  overflow-wrap: break-word !important;
  color: rgba(0, 0, 0, 1) !important;
  font-size: 16px !important;
  font-family: SourceHanSansCN-Medium !important;
  font-weight: 500 !important;
  text-align: center !important;
  white-space: nowrap !important;
  line-height: 16px !important;
  margin: 16px 0 0 4px !important;
}

.section_4 {
  background-color: rgba(222, 222, 222, 1) !important;
  width: 1px !important;
  height: 80px !important;
  margin: 16px 0 0 16px !important;
}

.text-wrapper_7 {
  width: auto !important;
  max-width: 100% !important;
  height: auto !important;
  min-height: 65px !important;
  margin: 23px 25px 0 15px !important;
  flex: 1 !important;
}

.text_33 {
  width: 100% !important;
  max-width: 100% !important;
  height: auto !important;
  min-height: 16px !important;
  overflow-wrap: break-word !important;
  color: rgba(0, 0, 0, 1) !important;
  font-size: 16px !important;
  font-family: AlibabaPuHuiTi_2_55_Regular !important;
  font-weight: normal !important;
  text-align: left !important;
  line-height: 1.2 !important;
  margin-left: 1px !important;
}

.text_34 {
  width: 100% !important;
  max-width: 100% !important;
  height: auto !important;
  min-height: auto !important;
  overflow-wrap: break-word !important;
  color: rgba(92, 92, 92, 1) !important;
  font-size: 14px !important;
  font-family: AlibabaPuHuiTi_2_55_Regular !important;
  font-weight: normal !important;
  text-align: left !important;
  line-height: 1.4 !important;
  margin-top: 14px !important;
}

/* 恢复 group_22 的原始样式 */
.group_22 {
  background-color: rgba(255, 255, 255, 1) !important;
  width: 504px !important;
  height: auto !important;
  min-height: 112px !important;
  border: 1px solid rgba(222, 222, 222, 1) !important;
  margin-top: 20px !important;
}

.group_23 {
  width: 72px !important;
  height: 67px !important;
  margin: 23px 0 0 16px !important;
}

.text_35 {
  width: 38px !important;
  height: 26px !important;
  overflow-wrap: break-word !important;
  color: rgba(0, 0, 0, 1) !important;
  font-size: 32px !important;
  font-family: SourceHanSansCN-Bold !important;
  font-weight: 700 !important;
  text-align: center !important;
  white-space: nowrap !important;
  line-height: 32px !important;
  margin-left: 17px !important;
}

.box_12 {
  background-color: rgba(0, 0, 0, 1) !important;
  width: 72px !important;
  height: 1px !important;
  margin-top: 11px !important;
}

.text_36 {
  width: 64px !important;
  height: 13px !important;
  overflow-wrap: break-word !important;
  color: rgba(0, 0, 0, 1) !important;
  font-size: 16px !important;
  font-family: SourceHanSansCN-Medium !important;
  font-weight: 500 !important;
  text-align: center !important;
  white-space: nowrap !important;
  line-height: 16px !important;
  margin: 16px 0 0 4px !important;
}

.group_24 {
  background-color: rgba(222, 222, 222, 1) !important;
  width: 1px !important;
  height: 80px !important;
  margin: 16px 0 0 16px !important;
}

.text-wrapper_8 {
  width: auto !important;
  max-width: 100% !important;
  height: auto !important;
  min-height: 65px !important;
  margin: 23px 25px 0 15px !important;
  flex: 1 !important;
}

.text_37 {
  width: 100% !important;
  max-width: 100% !important;
  height: auto !important;
  min-height: 16px !important;
  overflow-wrap: break-word !important;
  color: rgba(0, 0, 0, 1) !important;
  font-size: 16px !important;
  font-family: AlibabaPuHuiTi_2_55_Regular !important;
  font-weight: normal !important;
  text-align: left !important;
  line-height: 1.2 !important;
  margin-left: 1px !important;
}

.text_38 {
  width: 100% !important;
  max-width: 100% !important;
  height: auto !important;
  min-height: auto !important;
  overflow-wrap: break-word !important;
  color: rgba(92, 92, 92, 1) !important;
  font-size: 14px !important;
  font-family: AlibabaPuHuiTi_2_55_Regular !important;
  font-weight: normal !important;
  text-align: left !important;
  line-height: 1.4 !important;
  margin-top: 14px !important;
}

/* 恢复 section_5 的原始样式（在 block_8 内部） */
.block_8 .section_5 {
  width: 504px !important;
  height: 244px !important;
  margin: 133px 0 0 40px !important;
  position: relative !important;
  display: flex !important;
  flex-direction: column !important;
  justify-content: space-between !important;
}

/* 恢复 group_25 的原始样式 */
.group_25 {
  background-color: rgba(255, 255, 255, 1) !important;
  width: 504px !important;
  height: auto !important;
  min-height: 112px !important;
  border: 1px solid rgba(222, 222, 222, 1) !important;
}

.block_9 {
  width: 72px !important;
  height: 67px !important;
  margin: 23px 0 0 16px !important;
}

.text_39 {
  width: 38px !important;
  height: 26px !important;
  overflow-wrap: break-word !important;
  color: rgba(0, 0, 0, 1) !important;
  font-size: 32px !important;
  font-family: SourceHanSansCN-Bold !important;
  font-weight: 700 !important;
  text-align: center !important;
  white-space: nowrap !important;
  line-height: 32px !important;
  margin-left: 17px !important;
}

.box_13 {
  background-color: rgba(0, 0, 0, 1) !important;
  width: 72px !important;
  height: 1px !important;
  margin-top: 11px !important;
}

.text_40 {
  width: 64px !important;
  height: 13px !important;
  overflow-wrap: break-word !important;
  color: rgba(0, 0, 0, 1) !important;
  font-size: 16px !important;
  font-family: SourceHanSansCN-Medium !important;
  font-weight: 500 !important;
  text-align: center !important;
  white-space: nowrap !important;
  line-height: 16px !important;
  margin: 16px 0 0 4px !important;
}

.block_10 {
  background-color: rgba(222, 222, 222, 1) !important;
  width: 1px !important;
  height: 80px !important;
  margin: 16px 0 0 16px !important;
}

.text-wrapper_9 {
  width: auto !important;
  max-width: 100% !important;
  height: auto !important;
  min-height: 66px !important;
  margin: 22px 25px 0 16px !important;
  flex: 1 !important;
}

.text_41 {
  width: 100% !important;
  max-width: 100% !important;
  height: auto !important;
  min-height: 16px !important;
  overflow-wrap: break-word !important;
  color: rgba(0, 0, 0, 1) !important;
  font-size: 16px !important;
  font-family: AlibabaPuHuiTi_2_55_Regular !important;
  font-weight: normal !important;
  text-align: left !important;
  line-height: 1.2 !important;
}

.text_42 {
  width: 100% !important;
  max-width: 100% !important;
  height: auto !important;
  min-height: auto !important;
  overflow-wrap: break-word !important;
  color: rgba(92, 92, 92, 1) !important;
  font-size: 14px !important;
  font-family: AlibabaPuHuiTi_2_55_Regular !important;
  font-weight: normal !important;
  text-align: left !important;
  line-height: 1.4 !important;
  margin-top: 14px !important;
}

/* 恢复 group_26 的原始样式 */
.group_26 {
  background-color: rgba(255, 255, 255, 1) !important;
  width: 504px !important;
  height: auto !important;
  min-height: 112px !important;
  border: 1px solid rgba(222, 222, 222, 1) !important;
  margin-top: 20px !important;
}

.block_11 {
  width: 72px !important;
  height: 67px !important;
  margin: 23px 0 0 16px !important;
}

.text_43 {
  width: 38px !important;
  height: 26px !important;
  overflow-wrap: break-word !important;
  color: rgba(0, 0, 0, 1) !important;
  font-size: 32px !important;
  font-family: SourceHanSansCN-Bold !important;
  font-weight: 700 !important;
  text-align: center !important;
  white-space: nowrap !important;
  line-height: 32px !important;
  margin-left: 17px !important;
}

.box_14 {
  background-color: rgba(0, 0, 0, 1) !important;
  width: 72px !important;
  height: 1px !important;
  margin-top: 11px !important;
}

.text_44 {
  width: 64px !important;
  height: 13px !important;
  overflow-wrap: break-word !important;
  color: rgba(0, 0, 0, 1) !important;
  font-size: 16px !important;
  font-family: SourceHanSansCN-Medium !important;
  font-weight: 500 !important;
  text-align: center !important;
  white-space: nowrap !important;
  line-height: 16px !important;
  margin: 16px 0 0 4px !important;
}

.block_12 {
  background-color: rgba(222, 222, 222, 1) !important;
  width: 1px !important;
  height: 80px !important;
  margin: 16px 0 0 16px !important;
}

.text-wrapper_10 {
  width: auto !important;
  max-width: 100% !important;
  height: auto !important;
  min-height: 66px !important;
  margin: 22px 25px 0 16px !important;
  flex: 1 !important;
}

.text_45 {
  width: 100% !important;
  max-width: 100% !important;
  height: auto !important;
  min-height: 16px !important;
  overflow-wrap: break-word !important;
  color: rgba(0, 0, 0, 1) !important;
  font-size: 16px !important;
  font-family: AlibabaPuHuiTi_2_55_Regular !important;
  font-weight: normal !important;
  text-align: left !important;
  line-height: 1.2 !important;
}

.text_46 {
  width: 100% !important;
  max-width: 100% !important;
  height: auto !important;
  min-height: auto !important;
  overflow-wrap: break-word !important;
  color: rgba(92, 92, 92, 1) !important;
  font-size: 14px !important;
  font-family: AlibabaPuHuiTi_2_55_Regular !important;
  font-weight: normal !important;
  text-align: left !important;
  line-height: 1.4 !important;
  margin-top: 14px !important;
}

/* 恢复 box_15 的原始样式 */
/* box_15 自适应 - 始终位于页面中间 */
.box_15 {
  width: 100% !important;
  max-width: 151px !important;
  height: auto !important;
  min-height: 37px !important;
  margin: 48px auto 0 !important; /* 水平居中 */
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

/* text-wrapper_11 完全复制 text-wrapper_5 的样式（从 index.css 中的定义） */
.text-wrapper_11 {
  height: 37px !important;
  background: url(./assets/img/3cc0e1caa04f6422ef92ba704ce5d2f5.png) 100% no-repeat !important;
  background-size: 100% 100% !important;
  width: 151px !important;
  /* 完全复制 text-wrapper_5 的样式，只保留这 4 个属性：height, background, background-size, width */
  /* cursor 和 transition 保留在 hover 样式中 */
}

/* text_47 完全按照 text_21 的标准样式 */
.text_47 {
  width: 55px !important;
  height: 14px !important;
  overflow-wrap: break-word !important;
  color: rgba(255, 255, 255, 1) !important;
  font-size: 14px !important;
  font-family: AlibabaPuHuiTi_2_55_Regular !important;
  font-weight: normal !important;
  text-align: right !important;
  white-space: nowrap !important;
  line-height: 14px !important;
  margin: 11px 0 0 65px !important; /* 与 text_21 完全相同的 margin */
}

/* 恢复 box_16 的原始样式 */
.box_16 {
  width: 1062px !important;
  height: 59px !important;
  margin: 60px 0 0 858px !important; /* 继续减少 margin-top，使联系我们再上移 */
}

.text_48 {
  width: 193px !important;
  height: 43px !important;
  overflow-wrap: break-word !important;
  color: rgba(140, 48, 0, 1) !important;
  font-size: 40px !important; /* 从 47px 减小到 40px */
  font-family: KaiTi, 楷体, STKaiti, STKaitiSC-Regular !important; /* 改为楷体 */
  font-weight: normal !important; /* 改为正常字重 */
  text-align: left !important;
  white-space: nowrap !important;
  line-height: 40px !important; /* 相应调整行高 */
}

.image_5 {
  width: 837px !important;
  height: 59px !important;
}

/* 恢复 image-wrapper_2 的原始样式 */
.image-wrapper_2 {
  width: 113px !important;
  height: 249px !important;
  margin: 83px 0 184px 104px !important;
}

.image_6 {
  width: 113px !important;
  height: 249px !important;
}

/* 恢复 box_17 的原始样式 */
.box_17 {
  height: 486px !important; /* 根据参考代码，原始高度是 486px */
  background: url(./assets/img/a4c5f961e1e61a2eda143294eea73bfe.png) 100% no-repeat !important;
  background-size: 100% 100% !important;
  width: 1838px !important;
  position: absolute !important;
  left: 82px !important;
  top: 587px !important;
}

.text-wrapper_12 {
  width: 136px !important;
  height: 11px !important;
  margin: 13px 0 0 810px !important;
}

.text_49 {
  width: 136px !important;
  height: 11px !important;
  overflow-wrap: break-word !important;
  color: rgba(140, 48, 0, 1) !important;
  font-size: 15px !important;
  font-family: BookmanOldStyle !important;
  font-weight: normal !important;
  text-align: center !important;
  white-space: nowrap !important;
  line-height: 15px !important;
}

.group_27 {
  width: 768px !important;
  height: 168px !important;
  margin: 72px 0 222px 524px !important;
}

.box_18 {
  width: 105px !important;
  height: 117px !important;
}

.image-wrapper_3 {
  background-color: rgba(158, 112, 82, 1) !important;
  border-radius: 50% !important;
  height: 64px !important;
  margin-left: 22px !important;
  width: 64px !important;
}

.label_2 {
  width: 30px !important;
  height: 32px !important;
  margin: 16px 0 0 17px !important;
}

.text-group_1 {
  width: 105px !important;
  height: 38px !important;
  margin-top: 15px !important;
}

.text_50 {
  width: 26px !important;
  height: 14px !important;
  overflow-wrap: break-word !important;
  color: rgba(0, 0, 0, 1) !important;
  font-size: 14px !important;
  font-family: AlibabaPuHuiTi_2_55_Regular !important;
  font-weight: normal !important;
  text-align: center !important;
  white-space: nowrap !important;
  line-height: 14px !important;
  margin-left: 41px !important;
}

.text_51 {
  width: 105px !important;
  height: 13px !important;
  overflow-wrap: break-word !important;
  color: rgba(0, 0, 0, 1) !important;
  font-size: 16px !important;
  font-family: AlibabaPuHuiTi_2_55_Regular !important;
  font-weight: normal !important;
  text-align: center !important;
  white-space: nowrap !important;
  line-height: 16px !important;
  margin-top: 11px !important;
}

.box_19 {
  background-color: rgba(255, 255, 255, 1) !important;
  border-radius: 4px !important;
  width: 160px !important;
  height: 160px !important;
  border: 2px solid rgba(203, 185, 159, 1) !important;
  margin: 8px 0 0 169px !important;
}

.box_20 {
  width: 233px !important;
  height: 139px !important;
  margin-left: 101px !important;
}

.image-wrapper_4 {
  background-color: rgba(158, 112, 82, 1) !important;
  border-radius: 50% !important;
  height: 64px !important;
  margin-left: 87px !important;
  width: 64px !important;
}

.label_3 {
  width: 28px !important;
  height: 34px !important;
  margin: 15px 0 0 18px !important;
}

.text_52 {
  width: 27px !important;
  height: 14px !important;
  overflow-wrap: break-word !important;
  color: rgba(0, 0, 0, 1) !important;
  font-size: 14px !important;
  font-family: AlibabaPuHuiTi_2_55_Regular !important;
  font-weight: normal !important;
  text-align: center !important;
  white-space: nowrap !important;
  line-height: 14px !important;
  margin: 15px 0 0 107px !important;
}

.paragraph_1 {
  width: 233px !important;
  height: 36px !important;
  overflow-wrap: break-word !important;
  color: rgba(0, 0, 0, 1) !important;
  font-size: 16px !important;
  font-family: AlibabaPuHuiTi_2_55_Regular !important;
  font-weight: normal !important;
  text-align: center !important;
  line-height: 16px !important;
  margin-top: 10px !important;
}

.group_28 {
  height: 260px !important;
  background: url(./assets/img/cb264629d9f37767d042e1ce895e08e1.png) 100% no-repeat !important;
  background-size: 100% 100% !important;
  width: 100% !important;
  max-width: 1920px !important; /* 最大宽度限制 */
  position: absolute !important;
  left: 50% !important; /* 居中定位 */
  transform: translateX(-50%) !important; /* 通过 transform 实现真正的居中 */
  top: 1100px !important; /* 相对于 block_8：box_17的底部(587+486=1073px) + 间距27px = 1100px，确保在 box_17 下方 */
}


.box_21 {
  width: 781px !important;
  height: 16px !important;
  margin: 164px 0 0 565px !important;
}

.text_53 {
  width: 31px !important;
  height: 16px !important;
  overflow-wrap: break-word !important;
  color: rgba(255, 255, 255, 1) !important;
  font-size: 16px !important;
  font-family: AlibabaPuHuiTi_2_55_Regular !important;
  font-weight: normal !important;
  text-align: left !important;
  white-space: nowrap !important;
  line-height: 16px !important;
}

.box_22 {
  background-color: rgba(222, 222, 222, 1) !important;
  width: 1px !important;
  height: 16px !important;
  margin-left: 23px !important;
}

.text_54 {
  width: 61px !important;
  height: 16px !important;
  overflow-wrap: break-word !important;
  color: rgba(255, 255, 255, 1) !important;
  font-size: 16px !important;
  font-family: AlibabaPuHuiTi_2_55_Regular !important;
  font-weight: normal !important;
  text-align: left !important;
  white-space: nowrap !important;
  line-height: 16px !important;
  margin-left: 21px !important;
}

.box_23 {
  background-color: rgba(222, 222, 222, 1) !important;
  width: 1px !important;
  height: 16px !important;
  margin-left: 23px !important;
}

.text_55 {
  width: 62px !important;
  height: 15px !important;
  overflow-wrap: break-word !important;
  color: rgba(255, 255, 255, 1) !important;
  font-size: 16px !important;
  font-family: AlibabaPuHuiTi_2_55_Regular !important;
  font-weight: normal !important;
  text-align: left !important;
  white-space: nowrap !important;
  line-height: 16px !important;
  margin: 1px 0 0 21px !important;
}

.box_24 {
  background-color: rgba(222, 222, 222, 1) !important;
  width: 1px !important;
  height: 16px !important;
  margin-left: 22px !important;
}

.text_56 {
  width: 61px !important;
  height: 16px !important;
  overflow-wrap: break-word !important;
  color: rgba(255, 255, 255, 1) !important;
  font-size: 16px !important;
  font-family: AlibabaPuHuiTi_2_55_Regular !important;
  font-weight: normal !important;
  text-align: left !important;
  white-space: nowrap !important;
  line-height: 16px !important;
  margin-left: 22px !important;
}

.box_25 {
  background-color: rgba(222, 222, 222, 1) !important;
  width: 1px !important;
  height: 16px !important;
  margin-left: 22px !important;
}

.text_57 {
  width: 63px !important;
  height: 16px !important;
  overflow-wrap: break-word !important;
  color: rgba(255, 255, 255, 1) !important;
  font-size: 16px !important;
  font-family: AlibabaPuHuiTi_2_55_Regular !important;
  font-weight: normal !important;
  text-align: left !important;
  white-space: nowrap !important;
  line-height: 16px !important;
  margin-left: 22px !important;
}

.box_26 {
  background-color: rgba(222, 222, 222, 1) !important;
  width: 1px !important;
  height: 16px !important;
  margin-left: 22px !important;
}

.text_58 {
  width: 62px !important;
  height: 16px !important;
  overflow-wrap: break-word !important;
  color: rgba(255, 255, 255, 1) !important;
  font-size: 16px !important;
  font-family: AlibabaPuHuiTi_2_55_Regular !important;
  font-weight: normal !important;
  text-align: left !important;
  white-space: nowrap !important;
  line-height: 16px !important;
  margin-left: 23px !important;
}

.box_27 {
  background-color: rgba(222, 222, 222, 1) !important;
  width: 1px !important;
  height: 16px !important;
  margin-left: 22px !important;
}

.text_59 {
  width: 63px !important;
  height: 15px !important;
  overflow-wrap: break-word !important;
  color: rgba(255, 255, 255, 1) !important;
  font-size: 16px !important;
  font-family: AlibabaPuHuiTi_2_55_Regular !important;
  font-weight: normal !important;
  text-align: left !important;
  white-space: nowrap !important;
  line-height: 16px !important;
  margin: 1px 0 0 21px !important;
}

.box_28 {
  background-color: rgba(222, 222, 222, 1) !important;
  width: 1px !important;
  height: 16px !important;
  margin-left: 23px !important;
}

.text_60 {
  width: 63px !important;
  height: 16px !important;
  overflow-wrap: break-word !important;
  color: rgba(255, 255, 255, 1) !important;
  font-size: 16px !important;
  font-family: AlibabaPuHuiTi_2_55_Regular !important;
  font-weight: normal !important;
  text-align: left !important;
  white-space: nowrap !important;
  line-height: 16px !important;
  margin-left: 21px !important;
}

.text-wrapper_13 {
  width: 712px !important;
  height: 14px !important;
  margin: 31px 0 35px 603px !important;
}

.text_61 {
  width: 712px !important;
  height: 14px !important;
  overflow-wrap: break-word !important;
  color: rgba(255, 255, 255, 1) !important;
  font-size: 12px !important;
  font-family: AlibabaPuHuiTi_2_55_Regular !important;
  font-weight: normal !important;
  text-align: center !important;
  white-space: nowrap !important;
  line-height: 12px !important;
}

/* 恢复 image_7 的原始样式 */
.image_7 {
  position: absolute !important;
  left: 0 !important;
  top: 541px !important;
  width: 826px !important;
  height: 59px !important;
}

/* 园林景观项5的样式 - 与项4（box_32）保持一致 */
.box_34-wrapper {
  background-color: rgba(255, 255, 255, 1);
  position: absolute;
  left: 171px;
  top: -86px;
  width: 208px;
  height: 296px;
}

/* 当展开显示全部时，section_8 需要更高，把下面的内容推下去 */
/* 使用 transition 实现平滑过渡 */
/* 第三层：园林景观 - 改为相对定位，按顺序排列 */
.section_8 {
  min-height: 50px !important;
  height: auto !important;
  max-height: none !important;
  transition: min-height 0.3s ease !important;
  overflow: visible !important;
  position: relative !important;
  left: auto !important;
  top: auto !important;
  width: 100% !important;
  max-width: 1920px !important;
  padding-bottom: 60px !important;
  margin: 0 auto !important;
}

.section-8-expanded {
  /* 展开时根据实际内容高度自动调整，确保按钮不被遮挡 */
  /* 高度完全自适应内容，不设置固定min-height，让JS动态计算 */
  padding-bottom: 50px !important; /* 底部留出空间给按钮 */
}

/* box_4 图片放在 box_1 右上角 */
/* box_4-image 作为 block_5 的背景图放在右上角 */
.block_5 .box_4-image {
  position: absolute !important;
  right: 0 !important;
  top: 0 !important;
  width: 100% !important;
  max-width: 669px !important;
  height: auto !important;
  min-height: 915px !important;
  margin: 0 !important;
  object-fit: contain !important;
  z-index: 0 !important; /* 作为背景图，z-index 设为 0 */
  pointer-events: none !important; /* 不阻挡点击事件 */
}

/* 墓型展示区域 - box_1 自适应 */
.box_1 {
  position: relative !important;
  width: 100% !important;
  max-width: 1089px !important;
  height: auto !important;
  min-height: 405px !important;
  margin: 11px auto 0 !important;
  padding: 0 20px !important;
  box-sizing: border-box !important;
  display: flex !important;
  flex-wrap: wrap !important;
  align-items: flex-start !important;
  justify-content: center !important;
  gap: 20px !important;
}

/* image_4 放在左上角 */
.box_1 .image_4 {
  position: absolute !important;
  left: 0 !important;
  top: 0 !important;
  width: 100% !important;
  max-width: 282px !important;
  height: auto !important;
  min-height: 395px !important;
  margin: 0 !important;
  object-fit: contain !important;
  z-index: 1 !important;
}

/* group_11 样式 - 修复内部布局 */
.group_11 {
  width: auto !important;
  height: 458px;
  background: url(./assets/img/a74ef87aff6721f16b6be0ce3d0bd3d1.png) 100% no-repeat;
  background-size: 100% 100%;
  margin: 0 20px 0 10px;
  display: flex !important;
  flex-direction: row !important;
  align-items: flex-start !important;
  justify-content: flex-start !important;
  flex-wrap: nowrap !important; /* 不换行，确保所有按钮在同一行 */
  gap: 10px !important;
  position: relative !important;
  box-sizing: border-box !important;
  overflow-x: auto !important; /* 如果内容超出，允许横向滚动 */
}

/* 第二层：龙真墓地 - 改为相对定位，按顺序排列 */
.block_13 {
  position: relative !important; /* 改为相对定位 */
  left: auto !important;
  top: auto !important;
  width: auto !important;
  /* max-width: 1920px !important; */
  margin: 0 auto !important; /* 居中 */
  height: auto !important; /* 高度自适应 */
  overflow: visible !important;
  display: flex !important;
  flex-wrap: wrap !important;
  align-items: flex-start !important;
  justify-content: center !important;
  padding: 20px !important;
  box-sizing: border-box !important;
  background-image: url(./assets/img/897a10e8bd8cf0d02767b87eb2f60024.png) !important; /* image_8 作为 block_13 的背景图 */
  background-repeat: no-repeat !important;
  background-position: center !important;
  background-size: contain !important;
}

/* title-group-wrapper 容器 - 完全参照 news-header-left 的样式 */
.block_13 .title-group-wrapper {
  position: absolute !important;
  display: flex !important;
  flex-direction: row !important; /* 横向布局，让文字竖着排列 */
  align-items: flex-start !important;
  justify-content: flex-start !important;
  width: auto !important;
  height: auto !important;
  left: -260px !important;
  top: 50px !important;
  z-index: 10 !important;
  box-sizing: border-box !important;
  gap: 0 !important; /* 移除 gap，使用 margin 控制间距 */
}

/* block_13 内部元素自适应 - 完全参照 text_29 的样式 */
.block_13 .text_62 {
  width: auto !important;
  height: auto !important;
  overflow-wrap: break-word !important;
  color: rgba(92, 92, 92, 1) !important; /* 与 text_29 相同的颜色 */
  font-size: 16px !important; /* 与 text_29 相同的字体大小 */
  font-family: BookmanOldStyle !important; /* 与 text_29 相同的字体 */
  text-align: left !important;
  white-space: nowrap !important;
  line-height: 16px !important;
  margin: 0 !important;
  writing-mode: vertical-rl !important; /* 竖着展示 */
  text-orientation: mixed !important;
  letter-spacing: 3px !important; /* 与 text_29 相同的字间距 */
  flex-shrink: 0 !important;
  position: relative !important;
  left: 0 !important;
  top: 0 !important;
  z-index: 10 !important;
}

/* text_62 和 text_63 之间的分隔元素 - 完全参照 news-header-separator 的样式 */
.block_13 .title-group-wrapper .text-separator {
  width: 2px !important;
  height: 80px !important;
  min-height: 30px !important;
  background-color: rgba(149, 109, 83, 1) !important; /* 与 news-header-separator 相同的颜色 */
  position: relative !important;
  left: 0 !important;
  top: 0 !important;
  margin: 0 10px !important; /* 与 news-header-separator 相同的间距 */
  flex-shrink: 0 !important;
  display: block !important;
  z-index: 10 !important;
}

/* block_13 .text_63 - 完全参照 text_30 的样式 */
.block_13 .text_63 {
  width: auto !important;
  height: auto !important;
  overflow-wrap: break-word !important;
  color: rgba(0, 0, 0, 1) !important; /* 与 text_30 相同的颜色 */
  font-size: 40px !important; /* 与 text_30 相同的字体大小 */
  font-family: KaiTi, 楷体, STKaiti, STKaitiSC-Regular !important; /* 与 text_30 相同的字体 */
  font-weight: normal !important; /* 与 text_30 相同的字重 */
  text-align: left !important;
  white-space: nowrap !important;
  line-height: 40px !important; /* 与 text_30 相同的行高 */
  margin: 0 !important;
  writing-mode: vertical-rl !important; /* 竖着展示 */
  text-orientation: mixed !important;
  letter-spacing: 10px !important; /* 与 text_30 相同的字间距 */
  flex-shrink: 0 !important;
  position: relative !important;
  left: 0 !important;
  top: 0 !important;
  z-index: 10 !important;
}

.block_13 .text_64 {
  width: auto !important;
  height: auto !important;
  margin: 10px !important;
  flex-shrink: 0 !important;
  font-size: clamp(14px, 1.5vw, 18px) !important; /* 响应式字体：最小14px，最大18px */
  line-height: 1.2 !important;
}


.block_13 .section_7 {
  position: relative !important;
  left: auto !important;
  top: auto !important;
  width: 100% !important;
  max-width: 579px !important;
  min-width: 300px !important;
  height: 20px;
  min-height: 29px !important;
  margin: 20px !important;
  flex: 1 1 auto !important;
  background: url(./assets/img/04d8e1447ed225685c61a5165b1c72ee.png) -1px 0px no-repeat !important;
  background-size: 580px 360px !important;
  padding: 20px !important;
  padding-bottom: 320px !important;
  box-sizing: border-box !important;
}

.block_13 .text_65 {
  width: auto !important;
  height: auto !important;
  margin: 20px 0 10px 0 !important;
  font-size: clamp(18px, 2.2vw, 24px) !important; /* 响应式字体：最小18px，最大24px */
  line-height: 1.2 !important;
}

.block_13 .text_66 {
  width: 100% !important;
  max-width: 100% !important;
  height: auto !important;
  margin: 10px 0 !important;
  padding-bottom: 300px !important; /* 为 box_29 图片留出空间，避免文字被遮挡 */
  word-wrap: break-word !important;
  white-space: normal !important;
  font-size: clamp(12px, 1.2vw, 14px) !important; /* 响应式字体：最小12px，最大14px */
  line-height: 1.6 !important;
  position: relative !important;
  z-index: 1 !important;
}

.block_13 .box_29 {
  background: url(/files/images/zhutu.jpg) no-repeat !important;
  background-size: cover !important;
  background-position: center !important;
  position: absolute !important;
  left: 135% !important;
  transform: translateX(-50%) !important;
  bottom: 20px !important;
  width: 100% !important;
  max-width: 442px !important;
  height: 280px !important;
  z-index: 2 !important;
}


/* 墓葬展示列表样式 */
.shapes-list-wrapper {
  display: flex !important;
  flex-wrap: wrap !important;
  align-items: flex-start !important;
  justify-content: flex-start !important;
  width: 100% !important;
  max-width: 1200px !important;
  margin: 30px auto !important;
  padding: 0 20px !important;
}

.shape-item {
  width: 208px !important;
  margin: 0 10px 30px 10px !important;
  flex-shrink: 0;
}

.shape-image-wrapper {
  width: 208px !important;
  height: 168px !important;
  background-color: rgba(255, 255, 255, 1) !important;
  border: 1px solid rgba(222, 222, 222, 1) !important;
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.12) !important;
  overflow: hidden !important;
}

.shape-image {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
}

.shape-title {
  width: 100% !important;
  text-align: center !important;
  margin-top: 10px !important;
  font-size: 18px !important;
  color: rgba(0, 0, 0, 1) !important;
  font-family: AlibabaPuHuiTi_2_55_Regular !important;
}

/* 全部按钮非选中状态 - 与其他选项保持一致 */
.text-wrapper_2:not(.selected) {
  background: url(./assets/img/53cef548e55a57a1ce166ce3dbaa1e3c.png) 100% no-repeat !important;
  background-size: 100% 100% !important;
  height: 52px !important;
  width: 150px !important;
}

.text-wrapper_2:not(.selected) .text_12 {
  color: rgba(140, 48, 0, 1) !important;
}

/* 分类选中状态 - 改变背景色和文字颜色为白色，位置保持不变 */
.text-wrapper_2.selected,
.text-wrapper_3.selected,
.text-wrapper_4.selected {
  background: url(./assets/img/fc0ff83b99b2e317a75517a82ff681a3.png) 100% no-repeat !important;
  background-size: 100% 100% !important;
}

.text-wrapper_2.selected .text_12,
.text-wrapper_3.selected .text_13,
.text-wrapper_4.selected .text_14 {
  color: rgba(255, 255, 255, 1) !important;
}

/* 第四层：墓型展示 - 改为相对定位，按顺序排列 */
.block_5 {
  position: relative !important; /* 改为相对定位，用于绝对定位子元素 */
  margin-top: 0 !important; /* 移除固定margin-top */
  margin-bottom: 0 !important; /* 移除底部空白 */
  padding-bottom: 0 !important; /* 移除底部内边距 */
  width: 100% !important;
  max-width: 1920px !important;
  height: auto !important; /* 高度自适应 */
  min-height: auto !important;
  overflow: hidden !important; /* 防止背景图溢出 */
}

/* 墓型展示标题整体 - 完全参照 news-header-left 的样式 */
.block_5 .tomb-display-title-wrapper {
  position: absolute !important;
  right: -200px;
  top: -450px;
  display: flex !important;
  flex-direction: row !important; /* 横向布局，让文字竖着排列 */
  align-items: flex-start !important;
  justify-content: flex-start !important;
  z-index: 2 !important; /* 确保在背景图之上 */
  padding: 0 !important; /* 移除 padding */
  box-sizing: border-box !important;
  gap: 0 !important; /* 移除 gap，使用 margin 控制间距 */
}

/* 墓型展示标题文字 - text_22 - 完全参照 text_29 的样式 */
.block_5 .tomb-display-title-wrapper .text_22 {
  width: auto !important;
  height: auto !important;
  overflow-wrap: break-word !important;
  color: rgba(92, 92, 92, 1) !important; /* 与 text_29 相同的颜色 */
  font-size: 16px !important; /* 与 text_29 相同的字体大小 */
  font-family: BookmanOldStyle !important; /* 与 text_29 相同的字体 */
  text-align: left !important;
  white-space: nowrap !important;
  line-height: 16px !important;
  margin: 0 !important;
  writing-mode: vertical-rl !important; /* 竖着展示 */
  text-orientation: mixed !important;
  letter-spacing: 3px !important; /* 与 text_29 相同的字间距 */
}

/* 墓型展示标题之间的分隔线 - 完全参照 news-header-separator 的样式 */
.block_5 .tomb-display-title-wrapper .group_19 {
  width: 2px !important;
  height: 80px !important;
  min-height: 30px !important;
  background-color: rgba(149, 109, 83, 1) !important; /* 与 news-header-separator 相同的颜色 */
  position: relative !important;
  left: 0 !important;
  top: 0 !important;
  margin: 0 10px !important; /* 与 news-header-separator 相同的间距 */
  flex-shrink: 0 !important;
  display: block !important;
  z-index: 10 !important;
}

/* 墓型展示标题文字 - text_23 - 完全参照 text_30 的样式 */
.block_5 .tomb-display-title-wrapper .text_23 {
  width: auto !important;
  height: auto !important;
  overflow-wrap: break-word !important;
  color: rgba(0, 0, 0, 1) !important; /* 与 text_30 相同的颜色 */
  font-size: 40px !important; /* 与 text_30 相同的字体大小 */
  font-family: KaiTi, 楷体, STKaiti, STKaitiSC-Regular !important; /* 与 text_30 相同的字体 */
  font-weight: normal !important; /* 与 text_30 相同的字重 */
  text-align: left !important;
  white-space: nowrap !important;
  line-height: 40px !important; /* 与 text_30 相同的行高 */
  margin: 0 !important;
  writing-mode: vertical-rl !important; /* 竖着展示 */
  text-orientation: mixed !important;
  letter-spacing: 10px !important; /* 与 text_30 相同的字间距 */
}

/* box_3 自适应 */
.box_3 {
  width: 100% !important;
  max-width: 151px !important;
  height: auto !important;
  min-height: 37px !important;
  margin: 48px auto 0 !important;
  padding: 0 20px 0 !important;
  box-sizing: border-box !important;
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: center !important;
}

/* 第五层：在线购墓 - 改为相对定位，按顺序排列 */
.block_19 {
  position: relative !important; /* 改为相对定位 */
  left: auto !important;
  top: auto !important;
  width: 100% !important;
  max-width: 1920px !important;
  margin: 0 auto !important; /* 居中 */
  height: auto !important; /* 高度自适应 */
  padding: 60px 20px !important;
  box-sizing: border-box !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  overflow: hidden !important;
  background: none !important; /* 去掉背景图片 */
  background-color: transparent !important;
}

/* 在线购墓整体容器 - 左右结构 */
.online-purchase-wrapper {
  width: 100% !important;
  max-width: 100% !important; /* 确保不超出父容器 */
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important; /* 垂直居中 */
  justify-content: center !important; /* 水平居中 */
  gap: 40px !important;
  box-sizing: border-box !important;
  overflow: hidden !important; /* 防止内容溢出 */
  padding: 0 20px !important; /* 添加内边距，防止内容贴边 */
}

/* 左侧：标题部分（完全参照 news-header-left 的样式，但文字位于右侧） */
.online-purchase-header-left {
  flex: 0 0 auto !important; /* 改为 auto，允许缩小 */
  width: auto !important; /* 改为 auto，不固定宽度 */
  min-width: 200px !important; /* 设置最小宽度 */
  max-width: 33.333% !important; /* 设置最大宽度 */
  display: flex !important;
  flex-direction: row !important; /* 改为横向布局，让文字竖着排列 */
  align-items: center !important; /* 垂直居中 */
  justify-content: flex-end !important; /* 文字移动到右侧 */
  box-sizing: border-box !important;
  gap: 0 !important; /* 移除 gap，使用 margin 控制间距 */
  overflow: hidden !important; /* 防止内容溢出 */
  flex-shrink: 1 !important; /* 允许缩小 */
}

/* 在线购墓标题英文 - 完全参照 text_29 的样式 */
.online-purchase-header-left .text_69_en {
  width: auto !important;
  height: auto !important;
  overflow-wrap: break-word !important;
  color: rgba(92, 92, 92, 1) !important; /* 与 text_29 相同的颜色 */
  font-size: 16px !important; /* 与 text_29 相同的字体大小 */
  font-family: BookmanOldStyle !important; /* 与 text_29 相同的字体 */
  text-align: left !important;
  white-space: nowrap !important;
  line-height: 16px !important;
  margin: 0 !important;
  writing-mode: vertical-rl !important; /* 竖着展示 */
  text-orientation: mixed !important;
  letter-spacing: 3px !important; /* 与 text_29 相同的字间距 */
}

/* 在线购墓标题之间的分隔线 - 完全参照 news-header-separator 的样式 */
.online-purchase-separator {
  width: 2px !important;
  height: 80px !important;
  min-height: 30px !important;
  background-color: rgba(149, 109, 83, 1) !important; /* 与 news-header-separator 相同的颜色 */
  position: relative !important;
  left: 0 !important;
  top: 0 !important;
  margin: 0 10px !important; /* 与 news-header-separator 相同的间距 */
  flex-shrink: 0 !important;
  display: block !important;
  z-index: 10 !important;
}

/* 在线购墓标题中文 - 完全参照 text_30 的样式 */
.online-purchase-header-left .text_69 {
  width: auto !important;
  height: auto !important;
  overflow-wrap: break-word !important;
  color: rgba(0, 0, 0, 1) !important; /* 与 text_30 相同的颜色 */
  font-size: 40px !important; /* 从 48px 减小到 40px */
  font-family: KaiTi, 楷体, STKaiti, STKaitiSC-Regular !important; /* 改为楷体 */
  font-weight: normal !important; /* 改为正常字重 */
  text-align: left !important;
  white-space: nowrap !important;
  line-height: 40px !important; /* 相应调整行高 */
  margin: 0 !important;
  writing-mode: vertical-rl !important; /* 竖着展示 */
  text-orientation: mixed !important;
  letter-spacing: 10px !important; /* 与 text_30 相同的字间距 */
}

/* 右侧：图片和按钮容器（上下结构） */
.online-purchase-content {
  flex: 0 0 auto !important; /* 改为 auto，不自动扩展 */
  width: auto !important; /* 使用 auto，让 flex 控制宽度 */
  max-width: 873px !important; /* 设置最大宽度为 873px */
  min-width: 0 !important; /* 允许缩小到 0，防止溢出 */
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important; /* 水平居中 */
  justify-content: center !important; /* 垂直居中 */
  gap: 0 !important; /* 去掉间距，让按钮靠紧图片 */
  box-sizing: border-box !important;
  overflow: hidden !important; /* 防止内容溢出 */
}

/* 在线购墓图片 */
.online-purchase-image {
  width: 100% !important; /* 改为 100%，确保图片随容器缩放 */
  max-width: 100% !important; /* 确保不超出容器 */
  height: auto !important; /* 高度自适应，保持宽高比 */
  object-fit: contain !important; /* 保持图片比例，不裁剪 */
  display: block !important;
  box-sizing: border-box !important;
}

/* 在线购墓按钮 - 完全参照 image_17 (data-v-811c9d46) 的样式，居中显示 */
.online-purchase-content .text-wrapper_5 {
  width: 194px !important; /* 与 image_17 相同的宽度 */
  height: 62px !important; /* 与 image_17 相同的高度 */
  background: url(/files/images/goumu.jpg) 100% no-repeat !important; /* 使用 goumu.jpg 作为背景图片 */
  background-size: 100% 100% !important;
  cursor: pointer !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important; /* 内容居中 */
  padding-right: 20px !important; /* 右侧内边距 */
  margin-top: 10px !important; /* 减小间距，靠紧图片 */
  margin-left: auto !important; /* 自动左边距 */
  margin-right: auto !important; /* 自动右边距，使按钮居中 */
  box-sizing: border-box !important;
}

/* text_21 - 文字靠右展示 */
.online-purchase-content .text-wrapper_5 .text_21 {
  width: auto !important;
  height: auto !important;
  overflow-wrap: break-word !important;
  color: rgba(255, 255, 255, 1) !important; /* 白色文字 */
  font-size: 14px !important;
  font-family: AlibabaPuHuiTi_2_55_Regular !important;
  font-weight: normal !important;
  text-align: right !important; /* 右对齐 */
  white-space: nowrap !important;
  line-height: 14px !important;
  margin: 0 !important; /* 去掉边距，使用父容器的 justify-content 和 padding 来控制位置 */
}

/* 第六层：人文纪念 - 改为相对定位，按顺序排列 */
.block_22 {
  position: relative !important; /* 改为相对定位 */
  left: auto !important;
  top: auto !important;
  width: 100% !important;
  max-width: 1920px !important;
  margin: 0 auto !important; /* 居中 */
  height: auto !important; /* 高度自适应 */
  min-height: 1078px !important; /* 最小高度 */
  clear: both !important; /* 清除浮动，确保不叠加 */
  display: block !important; /* 确保是块级元素 */
  overflow: visible !important; /* 允许内容显示 */
  background-color: rgba(68, 76, 79, 1) !important; /* 背景色 rgba(68, 76, 79, 1) */
  background-image: none !important; /* 移除背景图片，确保背景色显示 */
}

/* box_39 人文纪念模块 - 自适应 */
.box_39 {
  position: relative !important; /* 改为相对定位 */
  left: auto !important;
  top: auto !important;
  width: 100% !important;
  max-width: 1918px !important;
  height: auto !important;
  min-height: 1078px !important;
  margin: 0 auto !important; /* 居中 */
  padding: 0 20px !important;
  box-sizing: border-box !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important; /* 垂直居中 */
  overflow: visible !important; /* 改为 visible，允许内容显示 */
  background: none !important; /* 移除背景图片，使用父元素的背景色 */
  background-color: transparent !important; /* 透明，让父元素的背景色显示 */
}

/* text-wrapper_18 自适应 - 始终保持在屏幕中间 */
.text-wrapper_18 {
  width: 100% !important;
  max-width: 151px !important;
  height: auto !important;
  min-height: 37px !important;
  margin: 48px auto 59px !important; /* 使用 auto 实现水平居中 */
  padding: 0 20px !important;
  box-sizing: border-box !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  background: url(./assets/img/68589b2b1a46c044fdd12522c0d55fa0.png) 100% no-repeat !important;
  background-size: 100% 100% !important;
}

/* box_39 内部元素自适应 - text_88 */
.box_39 .text_88 {
  width: auto !important;
  max-width: 196px !important;
  height: auto !important;
  min-height: 43px !important;
  overflow-wrap: break-word !important;
  color: rgba(255, 255, 255, 1) !important;
  font-size: clamp(28px, 4vw, 40px) !important; /* 响应式字体：最小28px，最大40px，减小字体 */
  font-family: KaiTi, 楷体, STKaiti, STKaitiSC-Regular !important; /* 改为楷体 */
  font-weight: normal !important; /* 改为正常字重 */
  text-align: left !important;
  white-space: nowrap !important;
  line-height: 1.2 !important; /* 使用相对行高 */
  margin: 99px 0 0 359px !important;
}

/* box_39 内部元素自适应 - box_40 */
.box_39 .box_40 {
  background-color: rgba(222, 222, 222, 1) !important;
  width: 100% !important;
  max-width: 88px !important;
  height: 2px !important;
  margin: 17px auto 0 !important; /* 居中 */
}

/* box_39 内部元素自适应 - text_89 */
.box_39 .text_89 {
  width: auto !important;
  max-width: 340px !important;
  height: auto !important;
  min-height: 13px !important;
  overflow-wrap: break-word !important;
  color: rgba(255, 255, 255, 1) !important;
  font-size: clamp(12px, 1.2vw, 16px) !important; /* 响应式字体 */
  font-family: BookmanOldStyle !important;
  font-weight: normal !important;
  text-align: left !important;
  white-space: nowrap !important;
  line-height: 16px !important;
  margin: 15px 0 0 364px !important;
}

/* box_39 内部元素自适应 - box_41 - 居中布局，分为3部分，紧贴无空隙，上下左右居中 */
.box_39 .box_41 {
  position: relative !important;
  width: 100% !important;
  max-width: 1559px !important;
  height: auto !important;
  min-height: 749px !important;
  margin: auto !important; /* 上下左右居中 */
  padding: 0 20px !important;
  box-sizing: border-box !important;
  display: flex !important;
  flex-direction: row !important;
  justify-content: center !important; /* 改为 center，让三个部分居中 */
  align-items: stretch !important; /* 改为 stretch，让所有元素等高 */
  gap: 0 !important; /* 移除间隙，让三个部分紧贴 */
  left: 0 !important; /* 移除向左移动 */
}

/* box_39 内部元素自适应 - section_12 - 向左移动 */
.box_39 .section_12 {
  width: 100% !important;
  max-width: 172px !important;
  height: auto !important;
  min-height: 167px !important;
  margin-top: 100px !important;
  flex: 0 0 auto !important;
  position: relative !important;
  left: 450px !important; /* 向左移动199px，与其他元素保持一致 */
  display: flex !important;
  flex-direction: column !important;
  justify-content: flex-start !important; /* 改为 flex-start，不使用 justify-between */
  gap: 0 !important; /* 不使用 gap，改用 margin-top */
}

/* box_39 内部元素自适应 - image-text_5 */
.box_39 .image-text_5 {
  width: 100% !important;
  max-width: 126px !important;
  height: auto !important;
  min-height: 23px !important;
  display: flex !important;
  align-items: center !important;
  gap: 10px !important;
  margin-top: 0 !important; /* 第一个元素不需要 margin-top */
}

.box_39 .label_4 {
  width: 100% !important;
  max-width: 22px !important;
  height: auto !important;
  min-height: 22px !important;
  object-fit: contain !important;
}

.box_39 .text-group_6 {
  width: auto !important;
  max-width: 92px !important;
  height: auto !important;
  min-height: 23px !important;
  overflow-wrap: break-word !important;
  color: rgba(255, 255, 255, 1) !important;
  font-size: clamp(18px, 2vw, 24px) !important; /* 响应式字体 */
  font-family: AlibabaPuHuiTi_2_55_Regular !important;
  font-weight: normal !important;
  text-align: left !important;
  white-space: nowrap !important;
  line-height: 1.2 !important;
}

/* box_39 内部元素自适应 - image-text_6 */
.box_39 .image-text_6 {
  width: 100% !important;
  max-width: 126px !important;
  height: auto !important;
  min-height: 23px !important;
  margin-top: 20px !important; /* 统一的间距 */
  display: flex !important;
  align-items: center !important;
  gap: 10px !important;
}

.box_39 .label_5 {
  width: 100% !important;
  max-width: 22px !important;
  height: auto !important;
  min-height: 22px !important;
  object-fit: contain !important;
}

.box_39 .text-group_7 {
  width: auto !important;
  max-width: 92px !important;
  height: auto !important;
  min-height: 23px !important;
  overflow-wrap: break-word !important;
  color: rgba(255, 255, 255, 1) !important;
  font-size: clamp(18px, 2vw, 24px) !important; /* 响应式字体 */
  font-family: AlibabaPuHuiTi_2_75_SemiBold !important;
  font-weight: normal !important;
  text-align: left !important;
  white-space: nowrap !important;
  line-height: 1.2 !important;
}

/* box_39 内部元素自适应 - image-text_7 */
.box_39 .image-text_7 {
  width: 100% !important;
  max-width: 172px !important;
  height: auto !important;
  min-height: 23px !important;
  margin-top: 20px !important; /* 统一的间距，与 image-text_6 保持一致 */
  display: flex !important;
  align-items: center !important;
  gap: 10px !important;
}

.box_39 .label_6 {
  width: 100% !important;
  max-width: 22px !important;
  height: auto !important;
  min-height: 22px !important;
  object-fit: contain !important;
}

.box_39 .text-group_8 {
  width: auto !important;
  max-width: 139px !important;
  height: auto !important;
  min-height: 23px !important;
  overflow-wrap: break-word !important;
  color: rgba(255, 255, 255, 1) !important;
  font-size: clamp(18px, 2vw, 24px) !important; /* 响应式字体 */
  font-family: AlibabaPuHuiTi_2_55_Regular !important;
  font-weight: normal !important;
  text-align: left !important;
  white-space: nowrap !important;
  line-height: 1.2 !important;
}

/* box_39 内部元素自适应 - section_13 - 第三部分，显示 renwen.jpg 图片，紧贴 */
.box_39 .section_13 {
  background: none !important;
  flex: 0 0 auto !important;
  width: auto !important;
  max-width: 100% !important;
  height: 100% !important; /* 设置为 100%，与 box_42 等高 */
  min-height: auto !important;
  margin: 0 !important; /* 移除所有 margin，确保紧贴 */
  padding: 0 !important; /* 移除所有 padding */
  position: relative !important;
  z-index: 1 !important;
  left: 0 !important; /* 移除偏移 */
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  overflow: hidden !important; /* 防止内容溢出 */
  box-sizing: border-box !important;
}

.renwen-image {
  width: 100% !important;
  max-width: 100% !important;
  height: 100% !important; /* 设置为 100%，与 box_42 等高 */
  object-fit: cover !important; /* 改为 cover，填充整个容器 */
  display: block !important; /* 移除图片底部间隙 */
  box-sizing: border-box !important;
}

/* 第一部分：renwen2.jpg 图片，上方显示文字，图片顶部与 box_42 对齐 */
.renwen2-wrapper {
  flex: 0 0 auto !important;
  width: auto !important;
  max-width: 100% !important; /* 确保不超出父容器 */
  height: auto !important;
  margin: 0 !important; /* 移除所有 margin，确保紧贴 */
  padding: 0 !important; /* 移除所有 padding */
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
  position: relative !important;
  align-self: flex-start !important; /* 顶部对齐 */
  overflow: hidden !important; /* 防止内容溢出 */
  box-sizing: border-box !important;
}

.renwen2-header {
  width: 100% !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  z-index: 1 !important;
  margin-bottom: 0 !important;
  transform: translateY(-100%) !important; /* 文字移到图片上方 */
  margin-bottom: 20px !important; /* 文字和图片之间的间距 */
}

.renwen2-wrapper .text_88 {
  width: auto !important;
  max-width: 196px !important;
  height: auto !important;
  min-height: 43px !important;
  overflow-wrap: break-word !important;
  color: rgba(255, 255, 255, 1) !important;
  font-size: clamp(32px, 4vw, 48px) !important; /* 响应式字体 */
  font-family: STKaitiSC-Bold !important;
  font-weight: 700 !important;
  text-align: left !important;
  white-space: nowrap !important;
  line-height: 48px !important;
  margin: 0 !important;
}

.renwen2-wrapper .box_40 {
  background-color: rgba(222, 222, 222, 1) !important;
  width: 100% !important;
  max-width: 88px !important;
  height: 2px !important;
  margin: 17px 0 0 !important;
}

.renwen2-wrapper .text_89 {
  width: auto !important;
  max-width: 340px !important;
  height: auto !important;
  min-height: 13px !important;
  overflow-wrap: break-word !important;
  color: rgba(255, 255, 255, 1) !important;
  font-size: clamp(12px, 1.2vw, 16px) !important; /* 响应式字体 */
  font-family: BookmanOldStyle !important;
  font-weight: normal !important;
  text-align: left !important;
  white-space: nowrap !important;
  line-height: 16px !important;
  margin: 15px 0 0 !important;
}

.renwen2-image {
  width: 100% !important;
  max-width: 100% !important;
  height: auto !important;
  object-fit: contain !important;
  display: block !important; /* 移除图片底部间隙 */
  margin-top: 0 !important; /* 图片顶部与 box_42 对齐 */
  position: relative !important;
  z-index: 0 !important;
  box-sizing: border-box !important;
}

/* box_39 内部元素自适应 - box_42 - 第二部分，居中，紧贴 */
.box_39 .box_42 {
  width: 100% !important;
  max-width: 378px !important;
  height: 742.97px !important; /* 设置固定高度为 742.97px */
  min-height: 742.97px !important;
  background: url(./assets/img/fd18f32fed6d241dbd9ae9e78013def1.png) 100% no-repeat !important;
  background-size: cover !important;
  background-position: center !important;
  margin: 0 !important; /* 移除所有 margin，确保紧贴 */
  padding: 0 20px !important;
  box-sizing: border-box !important;
  flex: 0 0 auto !important;
  position: relative !important;
  left: 0 !important; /* 移除偏移 */
}

/* box_39 内部元素自适应 - text_90 */
.box_39 .text_90 {
  width: auto !important;
  max-width: 122px !important;
  height: auto !important;
  min-height: 31px !important;
  overflow-wrap: break-word !important;
  color: rgba(140, 48, 0, 1) !important;
  font-size: clamp(24px, 3vw, 32px) !important; /* 响应式字体 */
  font-family: AlibabaPuHuiTi_2_75_SemiBold !important;
  font-weight: normal !important;
  text-align: center !important;
  white-space: nowrap !important;
  line-height: 32px !important;
  margin: 139px 0 0 128px !important;
}

/* box_39 内部元素自适应 - text_91 */
.box_39 .text_91 {
  width: auto !important;
  max-width: 238px !important;
  height: auto !important;
  min-height: 13px !important;
  overflow-wrap: break-word !important;
  color: rgba(140, 48, 0, 1) !important;
  font-size: clamp(12px, 1.2vw, 16px) !important; /* 响应式字体 */
  font-family: BookmanOldStyle !important;
  font-weight: normal !important;
  text-align: center !important;
  white-space: nowrap !important;
  line-height: 16px !important;
  margin: 22px 0 0 70px !important;
}

/* box_39 内部元素自适应 - block_23 */
.box_39 .block_23 {
  background-color: rgba(140, 48, 0, 1) !important;
  width: 4px !important;
  height: 24px !important;
  margin: 23px auto 0 !important; /* 居中 */
}

/* box_39 内部元素自适应 - paragraph_2 */
.box_39 .paragraph_2 {
  width: 100% !important;
  max-width: 251px !important;
  height: auto !important;
  min-height: 111px !important;
  overflow-wrap: break-word !important;
  color: rgba(92, 92, 92, 1) !important;
  font-size: clamp(12px, 1.2vw, 16px) !important; /* 响应式字体 */
  word-wrap: break-word !important;
  white-space: normal !important;
  font-family: AlibabaPuHuiTi_2_55_Regular !important;
  font-weight: normal !important;
  text-align: center !important;
  line-height: 24px !important;
  margin: 23px 0 0 63px !important;
}

/* box_39 内部元素自适应 - image_17 */
.box_39 .image_17 {
  width: 100% !important;
  max-width: 194px !important;
  height: auto !important;
  min-height: 62px !important;
  margin: 128px auto 162px !important; /* 居中 */
  object-fit: contain !important;
}

/* box_39 内部元素自适应 - image_18 */
.box_39 .image_18 {
  width: 100% !important;
  max-width: 306px !important;
  height: auto !important;
  min-height: 171px !important;
  margin: 416px auto 0 !important; /* 居中 */
  object-fit: contain !important;
}

/* box_39 内部元素自适应 - image_19 */
.box_39 .image_19 {
  position: relative !important; /* 改为相对定位 */
  left: auto !important;
  top: auto !important;
  width: 100% !important;
  max-width: 78px !important;
  height: auto !important;
  min-height: 78px !important;
  margin: 0 auto !important; /* 居中 */
  object-fit: contain !important;
}

/* 新闻资讯部分 - 新布局 */
/* 第一层：左右结构 */
.news-header-row-1 {
  width: 100% !important;
  max-width: 1200px !important;
  margin: 0 auto !important;
  padding: 0 20px !important;
  display: flex !important;
  flex-direction: row !important;
  align-items: flex-start !important;
  justify-content: flex-start !important;
  gap: 20px !important;
  box-sizing: border-box !important;
}

/* 左侧：标题部分（占1/3） */
.news-header-left {
  flex: 0 0 33.333% !important;
  width: 33.333% !important;
  display: flex !important;
  flex-direction: row !important; /* 改为横向布局，让文字竖着排列 */
  align-items: flex-start !important;
  justify-content: flex-start !important;
  box-sizing: border-box !important;
  gap: 0 !important; /* 移除 gap，使用 margin 控制间距 */
}

.news-header-left .text_29 {
  width: auto !important;
  height: auto !important;
  overflow-wrap: break-word !important;
  color: rgba(92, 92, 92, 1) !important;
  font-size: 16px !important;
  font-family: BookmanOldStyle !important;
  text-align: left !important;
  white-space: nowrap !important;
  line-height: 16px !important;
  margin: 0 !important;
  writing-mode: vertical-rl !important; /* 竖着展示 */
  text-orientation: mixed !important;
  letter-spacing: 3px !important;
}

/* 新闻资讯标题之间的分隔线 - 类似 text-separator 的样式 */
.news-header-separator {
  width: 2px !important;
  height: 80px !important;
  min-height: 30px !important;
  background-color: rgba(149, 109, 83, 1) !important; /* 与 text-separator 相同的颜色 */
  position: relative !important;
  left: 0 !important;
  top: 0 !important;
  margin: 0 10px !important; /* 减小间距，使更紧凑 */
  flex-shrink: 0 !important;
  display: block !important;
  z-index: 10 !important;
}

.news-header-left .text_30 {
  width: auto !important;
  height: auto !important;
  overflow-wrap: break-word !important;
  color: rgba(0, 0, 0, 1) !important;
  font-size: 40px !important; /* 从 48px 减小到 40px */
  font-family: KaiTi, 楷体, STKaiti, STKaitiSC-Regular !important; /* 改为楷体 */
  font-weight: normal !important; /* 改为正常字重 */
  text-align: left !important;
  white-space: nowrap !important;
  line-height: 40px !important; /* 相应调整行高 */
  margin: 0 !important;
  writing-mode: vertical-rl !important; /* 竖着展示 */
  text-orientation: mixed !important;
  letter-spacing: 10px !important;
}

/* 右侧：新闻列表容器（占2/3） */
.news-list-wrapper {
  flex: 0 0 66.666% !important;
  width: 66.666% !important;
  display: flex !important;
  flex-direction: row !important;
  align-items: flex-start !important;
  justify-content: flex-start !important;
  gap: 20px !important;
  box-sizing: border-box !important;
  margin-left: -100px !important; /* 向左移动 100px */
}

/* 新闻列（每列占1/3，两列共2/3） */
.news-list-column {
  flex: 0 0 50% !important;
  width: 50% !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
  justify-content: flex-start !important;
  gap: 20px !important;
  box-sizing: border-box !important;
}

/* 统一新闻项的样式，确保两列对齐 */
.news-list-column .group_21,
.news-list-column .group_22,
.news-list-column .group_25,
.news-list-column .group_26 {
  width: 100% !important;
  max-width: 100% !important;
  margin-top: 0 !important; /* 统一移除 margin-top，使用 gap 控制间距 */
  margin-left: 0 !important;
  margin-right: 0 !important;
  margin-bottom: 0 !important;
  box-sizing: border-box !important;
}

/* 确保新闻项内部元素也统一宽度 */
.news-list-column .group_21,
.news-list-column .group_22,
.news-list-column .group_25,
.news-list-column .group_26 {
  height: auto !important;
  min-height: 112px !important;
}

/* 第二层：查看全部按钮 */
.news-header-row-2 {
  width: 100% !important;
  max-width: 1200px !important;
  margin: 30px auto 0 !important;
  padding: 0 20px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-sizing: border-box !important;
}

/* 第七层：新闻资讯列表部分 - 改为相对定位，按顺序排列 */
.section_5 {
  position: relative !important; /* 改为相对定位 */
  width: 100% !important;
  max-width: 1920px !important;
  margin: 0 auto !important; /* 居中，移除左侧margin */
  height: auto !important; /* 高度自适应 */
  display: flex !important;
  flex-direction: column !important;
  gap: 20px !important;
  z-index: 1 !important;
  clear: both !important; /* 清除浮动，确保不叠加 */
  overflow: visible !important; /* 允许内容显示 */
  min-height: 0 !important; /* 移除最小高度限制 */
}


/* 第一层：头部标题部分 */
.garden-header {
  width: 100% !important;
  max-width: 1200px !important;
  height: auto !important;
  margin: 57px auto 0 !important; /* 居中显示 */
  padding: 0 20px !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: flex-start !important;
  position: relative !important;
  box-sizing: border-box !important;
}

/* 第一层：图片 + 标题 + 图片 */
.garden-header-row-1 {
  width: 100% !important;
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: center !important;
  position: relative !important;
  box-sizing: border-box !important;
  margin-left: -298px !important; /* 向左移动 50px */
}

/* 左侧装饰图片 */
.garden-header-left {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: auto;
  margin-right: 18px !important; /* 与中间标题的间距 */
}

.garden-header-left .image_10 {
  width: 476px !important;
  height: 17px !important;
  margin-top: 15px !important;
  display: block !important;
}

/* 中间标题文字 */
.garden-header-center {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: auto;
}

.garden-header-center .text_67 {
  width: auto !important;
  height: 44px !important;
  overflow-wrap: break-word;
  color: rgba(140, 48, 0, 1) !important;
  font-size: 40px !important; /* 从 48px 减小到 40px */
  font-family: KaiTi, 楷体, STKaiti, STKaitiSC-Regular !important; /* 改为楷体 */
  font-weight: normal !important; /* 改为正常字重 */
  text-align: center !important;
  white-space: nowrap !important;
  line-height: 40px !important; /* 相应调整行高 */
  margin: 0 !important;
}

/* 右侧装饰图片 */
.garden-header-right {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: auto;
  margin-left: 18px !important; /* 与中间标题的间距 */
}

.garden-header-right .image_12 {
  width: 475px !important;
  height: 17px !important;
  margin-top: 15px !important;
  display: block !important;
}

/* 第二层：英文副标题 */
.garden-header-row-2 {
  width: 100% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  margin-top: 10px !important;
  box-sizing: border-box !important;
}

.garden-header-row-2 .text_68 {
  width: auto !important;
  height: auto !important;
  overflow-wrap: break-word;
  color: rgba(140, 48, 0, 1) !important;
  font-size: 16px !important;
  font-family: BookmanOldStyle !important;
  text-align: center !important;
  white-space: nowrap !important;
  line-height: 16px !important;
  margin: 0 !important;
}

/* 第二层：中间列表部分 - 从左侧开始排列 */
.garden-list-wrapper {
  display: flex !important;
  flex-wrap: wrap !important;
  align-items: flex-start !important;
  justify-content: flex-start !important; /* 左对齐，当换行时第二行也会左对齐 */
  width: 100% !important;
  max-width: 1300px !important; /* 增加最大宽度，确保能容纳5个卡片：208px * 5 + 30px * 5 = 1190px，加上padding需要至少1230px */
  margin: 50px auto !important; /* 容器居中，这样整体看起来居中，但内部内容左对齐 */
  padding: 0 20px !important;
  position: relative !important;
  min-height: 300px;
}

/* 统一所有列表项的样式 - 全部使用 block_14 结构 */
.garden-list-wrapper .block_14 {
  margin: 0 10px 30px 10px !important; /* 减小左右间距，确保5个卡片能在一行显示：208px * 5 + 20px * 5 = 1140px */
  flex-shrink: 1 !important; /* 允许缩小 */
  flex-grow: 0 !important; /* 不允许放大 */
  flex-basis: 208px !important; /* 使用 flex-basis 设置基础宽度，允许 flex-shrink 生效 */
  width: auto !important; /* 使用 auto，让 flexbox 控制宽度 */
  height: auto !important; /* 使用 auto，让 aspect-ratio 控制高度 */
  box-sizing: border-box !important;
  /* 允许响应式缩放 - 当容器宽度不足时，卡片会自动缩小 */
  min-width: 150px !important;
  max-width: 208px !important;
  /* 当宽度变化时，高度按比例调整 */
  aspect-ratio: 208 / 296 !important; /* 保持宽高比，当宽度缩小时高度也会按比例缩小 */
  min-height: calc(150px * 296 / 208) !important; /* 最小高度，基于最小宽度计算：150 * 296/208 ≈ 213px */
  max-height: 296px !important; /* 最大高度 */
}

/* 确保 block_14 内部的图片和容器保持等比例 */
.garden-list-wrapper .block_14 .image-text_1 {
  width: 100% !important;
  height: calc(100% - 16px) !important; /* 减去文字区域高度 */
  box-sizing: border-box !important;
  display: flex !important;
  flex-direction: column !important;
  justify-content: space-between !important;
  align-items: center !important; /* 确保内容居中 */
}

.garden-list-wrapper .block_14 .box_30 {
  width: 100% !important;
  height: calc(100% - 32px) !important; /* 减去文字区域高度 */
  box-sizing: border-box !important;
  background-color: rgba(255, 221, 221, 1) !important;
}

.garden-list-wrapper .block_14 .box_30 img {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
}

.garden-list-wrapper .block_14 .text-group_2 {
  width: 100% !important; /* 占满容器宽度，确保居中 */
  height: auto !important;
  margin: 8px 0 0 0 !important; /* 移除左侧 margin，确保居中 */
  text-align: center !important;
  font-size: clamp(14px, 1.2vw, 18px) !important;
  line-height: clamp(14px, 1.2vw, 18px) !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

/* 第三层：底部按钮部分 */
.garden-footer {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  width: 100% !important;
  margin-top: 30px !important;
  padding: 20px 0 40px 0 !important; /* 增加底部padding，确保按钮完整显示 */
  min-height: 95px !important; /* 确保按钮区域有足够高度（35px按钮 + 上下padding） */
}

.garden-footer .image_11 {
  display: block !important;
  margin: 0 auto !important;
}

/* 统一渲染的园林景观项样式 - 支持多行 */
.garden-item-unified {
  background-color: rgba(255, 255, 255, 1);
  width: 208px;
  height: 296px;
  position: relative;
  flex-shrink: 0;
}

/* 按钮在展开时下移 - 通过JS动态计算 */
.image_11 {
  transition: margin-top 0.3s ease !important;
}

/* 修复购墓价格文字溢出问题 */
.text-wrapper_14,
.text-wrapper_15,
.text-wrapper_16,
.text-wrapper_17 {
  width: 100px !important; /* 增加宽度以容纳"无参考价"等文字 */
  min-width: 100px !important;
  overflow: visible !important;
}

.text_74,
.text_78,
.text_82,
.text_86 {
  width: auto !important; /* 改为自动宽度，让文字自然显示 */
  max-width: 100px !important;
  overflow: visible !important;
  white-space: nowrap !important;
}

/* 首页 block_1 样式修改 */
.block_1 {
  background-color: rgba(255, 255, 255, 1) !important;
  position: relative !important;
  width: auto !important;
  max-width: none !important;
  height: auto !important;
  margin: 0 auto !important;
}

/* 中等屏幕适配 (1024px - 1366px) */

@media screen and (max-width: 768px) {
   .text-content-wrapper{
 
 }
 }
@media screen and (max-width: 1366px) and (min-width: 1025px) {
  .page,
  .block_1,
  .group_1,
  .block_13,
  .section_8,
  .block_5,
  .block_19,
  .block_22,
  .section_5 {
    width: 100% !important;
    max-width: 100% !important;
  }

  /* block_13 内部元素中等屏幕适配 */

  .block_13 .section_7 {
    max-width: 500px !important;
  }

  .block_13 .box_29 {
    max-width: 350px !important;
  }

  /* 中等屏幕字体大小调整 */
  .block_13 .text_62 {
    font-size: clamp(9px, 1vw, 13px) !important;
  }

  .block_13 .text_63 {
    font-size: clamp(24px, 3.5vw, 40px) !important;
  }

  .block_13 .text_64 {
    font-size: clamp(13px, 1.3vw, 16px) !important;
  }

  .block_13 .text_65 {
    font-size: clamp(16px, 2vw, 22px) !important;
  }

  .block_13 .text_66 {
    font-size: clamp(11px, 1.1vw, 13px) !important;
  }

  .banner-wrapper {
    width: 100% !important;
    max-width: 100% !important;
  }

  .shapes-list-wrapper {
    max-width: 90% !important;
    margin: 30px auto !important;
    padding: 0 20px !important;
  }

  .garden-list-wrapper {
    max-width: 90% !important;
    margin: 20px auto !important;
    padding: 0 20px !important;
  }

  /* 人文纪念模块中等屏幕响应式优化 */
  .block_22 {
    padding: 40px 15px !important;
    overflow: hidden !important;
  }

  .box_39 {
    padding: 40px 15px !important;
    overflow: hidden !important;
  }

  .box_39 .box_41 {
    max-width: 100% !important;
    padding: 0 15px !important;
    gap: 0 !important; /* 移除间隙，让 box_42 和 section_13 靠紧 */
    flex-wrap: nowrap !important; /* 保持横向布局 */
    min-height: auto !important;
  }

  .renwen2-wrapper {
    flex: 0 0 auto !important;
    min-width: 0 !important;
    max-width: 30% !important;
    width: auto !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  .renwen2-image {
    width: 100% !important;
    max-width: 100% !important;
    height: auto !important;
    object-fit: contain !important;
    box-sizing: border-box !important;
  }

  .box_39 .box_42 {
    flex: 0 0 auto !important;
    width: auto !important;
    max-width: 35% !important;
    height: auto !important;
    min-height: 500px !important;
    padding: 15px !important;
    margin: 0 !important; /* 移除 margin，确保靠紧 */
  }

  .box_39 .section_13 {
    flex: 0 0 auto !important;
    width: auto !important;
    max-width: 35% !important;
    height: auto !important;
    min-height: 500px !important;
    margin: 0 !important; /* 移除 margin，确保靠紧 */
    padding: 0 !important; /* 移除 padding，确保靠紧 */
  }

  .renwen-image {
    width: 100% !important;
    max-width: 100% !important;
    height: 100% !important;
    object-fit: cover !important;
    box-sizing: border-box !important;
    margin: 0 !important; /* 移除 margin，确保靠紧 */
  }
}

/* 小屏幕适配 (768px - 1024px) */
@media screen and (max-width: 1024px) and (min-width: 769px) {
  .page,
  .block_1,
  .group_1,
  .block_13,
  .section_8,
  .block_5,
  .block_19,
  .block_22,
  .section_5 {
    width: 100% !important;
    max-width: 100% !important;
  }

  /* block_13 内部元素小屏幕适配 */
  .block_13 {
    flex-direction: column !important;
    align-items: center !important;
  }


  .block_13 .section_7 {
    max-width: 100% !important;
    width: 100% !important;
  }

  .block_13 .box_29 {
    max-width: 100% !important;
    width: 100% !important;
  }

  /* 小屏幕字体大小调整 */
  .block_13 .text_62 {
    font-size: clamp(8px, 1.5vw, 12px) !important;
  }

  .block_13 .text_63 {
    font-size: clamp(20px, 5vw, 35px) !important;
  }

  .block_13 .text_64 {
    font-size: clamp(12px, 2vw, 16px) !important;
  }

  .block_13 .text_65 {
    font-size: clamp(16px, 3vw, 22px) !important;
  }

  .block_13 .text_66 {
    font-size: clamp(11px, 1.8vw, 14px) !important;
  }

  .banner-wrapper {
    width: 100% !important;
    max-width: 100% !important;
    min-height: 350px !important;
  }

  .shapes-list-wrapper {
    max-width: 95% !important;
    margin: 20px auto !important;
    padding: 0 15px !important;
  }

  .garden-list-wrapper {
    max-width: 95% !important;
    margin: 20px auto !important;
    padding: 0 15px !important;
  }

  /* 在线购墓模块小屏幕响应式优化 */
  .block_19 {
    padding: 30px 10px !important;
    overflow: hidden !important;
  }

  .online-purchase-wrapper {
    flex-direction: row !important; /* 保持横向布局 */
    gap: 20px !important;
    padding: 0 10px !important;
    overflow: hidden !important;
  }

  .online-purchase-header-left {
    flex: 0 0 auto !important;
    width: auto !important;
    min-width: 150px !important;
    max-width: 30% !important;
    overflow: hidden !important;
  }

  .online-purchase-content {
    flex: 1 1 auto !important;
    width: auto !important;
    max-width: 70% !important;
    min-width: 0 !important;
    overflow: hidden !important;
  }

  .online-purchase-image {
    width: 100% !important;
    max-width: 100% !important;
    height: auto !important;
    object-fit: contain !important;
    box-sizing: border-box !important;
  }

  .garden-list-wrapper .block_14 {
    width: calc(33.333% - 20px) !important;
    height: calc((33.333% - 20px) * 1.423) !important; /* 保持宽高比 208:296 ≈ 1:1.423 */
    margin: 0 10px 20px 10px !important;
    min-width: 180px !important;
    max-width: 208px !important;
    min-height: 256px !important;
    max-height: 296px !important;
    flex-shrink: 1 !important; /* 允许缩小 */
  }

  /* 确保内部元素按比例缩放 */
  .garden-list-wrapper .block_14 .image-text_1 {
    width: 100% !important;
    height: calc(100% - 16px) !important;
  }

  .garden-list-wrapper .block_14 .box_30 {
    width: 100% !important;
    height: calc(100% - 32px) !important;
  }

  /* 确保文字居中 */
  .garden-list-wrapper .block_14 .text-group_2 {
    width: 100% !important;
    margin: 8px 0 0 0 !important;
    text-align: center !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
  }

  /* 人文纪念模块小屏幕响应式优化 */
  .block_22 {
    padding: 30px 10px !important;
    overflow: hidden !important;
  }

  .box_39 {
    padding: 30px 10px !important;
    overflow: hidden !important;
  }

  .box_39 .box_41 {
    max-width: 100% !important;
    padding: 0 10px !important;
    gap: 0 !important; /* 移除间隙，让 box_42 和 section_13 靠紧 */
    flex-wrap: wrap !important; /* 允许换行 */
    min-height: auto !important;
  }

  .renwen2-wrapper {
    flex: 1 1 auto !important;
    min-width: 0 !important;
    max-width: 100% !important;
    width: 100% !important;
  }

  .renwen2-image {
    width: 100% !important;
    max-width: 100% !important;
    height: auto !important;
    object-fit: contain !important;
    box-sizing: border-box !important;
  }

  .box_39 .box_42 {
    flex: 1 1 auto !important;
    width: 100% !important;
    max-width: 100% !important;
    height: auto !important;
    min-height: auto !important;
    padding: 15px !important;
    margin: 0 !important; /* 移除 margin，确保靠紧 */
  }

  .box_39 .section_13 {
    flex: 1 1 auto !important;
    width: 100% !important;
    max-width: 100% !important;
    height: auto !important;
    min-height: auto !important;
    margin: 0 !important; /* 移除 margin，确保靠紧 */
    padding: 0 !important; /* 移除 padding，确保靠紧 */
  }

  .renwen-image {
    width: 100% !important;
    max-width: 100% !important;
    height: auto !important;
    object-fit: contain !important;
    box-sizing: border-box !important;
    margin: 0 !important; /* 移除 margin，确保靠紧 */
  }
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .page {
    width: 100% !important;
    max-width: 100% !important;
    overflow-x: hidden !important;
  }
   .tea{
    display: flex;
    flex-direction: column !important;
  
   }
  .block_1,
  .group_1 {
    width: 100% !important;
    max-width: 100% !important;
  }

  /* 导航栏在移动端隐藏，使用移动端导航 */
  .header-nav {
    position: relative !important;
    width: 100% !important;
    left: 0 !important;
    height: auto !important;
    background-size: cover !important;
  }

  .header-content {
    width: 100% !important;
    margin: 10px !important;
    padding: 10px !important;
    flex-wrap: wrap !important;
  }

  .header-title {
    font-size: 24px !important;
    margin: 5px 0 0 10px !important;
  }

  .header-phone-icon {
    margin: 6px 0 0 20px !important;
  }

  .header-menu {
    width: 100% !important;
    margin: 10px 0 !important;
    padding: 0 10px !important;
    flex-wrap: wrap !important;
    justify-content: center !important;
  }

  .menu-item {
    font-size: 14px !important;
    margin: 5px !important;
  }

  .menu-divider {
    display: none !important;
  }

  /* 轮播图 */
  .banner-wrapper {
    width: 100% !important;
    height: auto !important;
  }

  .banner-wrapper img {
    width: 100% !important;
    height: auto !important;
  }

  .banner-swipe {
    width: 100% !important;
    height: auto !important;
    max-height: 300px !important;
  }

  .banner-item {
    width: 100% !important;
  }

  .banner-image {
    width: 100% !important;
    height: auto !important;
    max-height: 300px !important;
    object-fit: cover !important;
  }

  .image_2 {
    width: 100% !important;
    max-width: 200px !important;
    height: auto !important;
    margin: 10px auto !important;
    display: block !important;
  }

  /* 园林景观列表 */
  .garden-list-wrapper {
    max-width: 100% !important;
    padding: 0 10px !important;
    margin: 20px auto !important;
  }

  .garden-list-wrapper .block_14,
  .garden-item-unified {
    width: calc(50% - 10px) !important;
    height: calc((50% - 10px) * 1.423) !important; /* 保持宽高比 208:296 ≈ 1:1.423 */
    margin: 0 5px 20px 5px !important;
    max-width: 180px !important;
    max-height: 256px !important;
    min-width: 150px !important;
    min-height: 213px !important;
    flex-shrink: 1 !important; /* 允许缩小 */
  }

  /* 确保内部元素按比例缩放 */
  .garden-list-wrapper .block_14 .image-text_1,
  .garden-item-unified .image-text_1 {
    width: 100% !important;
    height: calc(100% - 16px) !important;
  }

  .garden-list-wrapper .block_14 .box_30,
  .garden-item-unified .box_30 {
    width: 100% !important;
    height: calc(100% - 32px) !important;
  }

  /* 确保文字居中 */
  .garden-list-wrapper .block_14 .text-group_2,
  .garden-item-unified .text-group_2 {
    width: 100% !important;
    margin: 8px 0 0 0 !important;
    text-align: center !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
  }

  /* 确保文字居中 */
  .garden-list-wrapper .block_14 .text-group_2,
  .garden-item-unified .text-group_2 {
    width: 100% !important;
    margin: 8px 0 0 0 !important;
    text-align: center !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
  }

  /* 在线购墓卡片 */
  .cemetery-card {
    width: calc(50% - 10px) !important;
    margin: 0 5px 20px 5px !important;
  }

  /* 文字大小调整 */
  .text_1, .text_2, .text_3 {
    font-size: 14px !important;
  }

  /* 页脚 */
  .footer-wrapper {
    position: relative !important;
    width: 100% !important;
    left: 0 !important;
    top: auto !important;
  }

  .footer-section {
    width: 100% !important;
    max-width: 100% !important;
  }

  .footer-menu {
    flex-wrap: wrap !important;
    justify-content: center !important;
    width: 100% !important;
    margin: 20px 0 !important;
    padding: 0 10px !important;
  }

  .footer-menu-item {
    font-size: 12px !important;
    margin: 5px !important;
  }

  .footer-menu-divider {
    display: none !important;
  }

  .footer-contact {
    flex-direction: column !important;
    align-items: center !important;
    width: 100% !important;
    margin: 20px 0 !important;
    padding: 0 10px !important;
  }

  .footer-phone,
  .footer-qrcode,
  .footer-address {
    margin: 10px 0 !important;
  }

  /* block_13 - 龙真墓地部分 - 收缩成轮播图样式 */
  .block_13 {
    width: 100% !important;
    padding: 0 !important;
    margin: 0 !important;
    flex-direction: column !important;
    align-items: stretch !important;
    position: relative !important;
    overflow: hidden !important;
    min-height: 200px !important;
    max-height: 300px !important;
    background-color: #f5f5f5 !important;
  }

  /* 隐藏大部分文字内容和装饰元素 */
  .text_62,
  .text_64,
  .section_7,
  .text_66,
  .box_29,
  .image_9 {
    display: none !important;
  }

  /* 主标题 - 叠加在图片上 */
  .text_63 {
    position: absolute !important;
    top: 20px !important;
    left: 50% !important;
    transform: translateX(-50%) !important;
    font-size: clamp(20px, 6vw, 28px) !important; /* 移动端响应式字体 */
    font-weight: bold !important;
    color: rgba(255, 255, 255, 1) !important;
    text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.7) !important;
    z-index: 10 !important;
    margin: 0 !important;
    white-space: nowrap !important;
    pointer-events: none !important;
  }

  /* 副标题 - 叠加在图片上 */
  .text_65 {
    position: absolute !important;
    bottom: 20px !important;
    left: 50% !important;
    transform: translateX(-50%) !important;
    font-size: clamp(14px, 4vw, 18px) !important; /* 移动端响应式字体 */
    color: rgba(255, 255, 255, 1) !important;
    text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.7) !important;
    z-index: 10 !important;
    margin: 0 !important;
    white-space: nowrap !important;
    pointer-events: none !important;
  }

  /* 移动端 block_13 其他文字自适应 */
  .block_13 .text_62 {
    font-size: clamp(7px, 2vw, 11px) !important;
  }

  .block_13 .text_64 {
    font-size: clamp(11px, 3vw, 15px) !important;
  }

  .block_13 .text_66 {
    font-size: clamp(10px, 2.5vw, 13px) !important;
    line-height: 1.5 !important;
  }

  /* 图片占满整个区域，类似轮播图 */
  .image_8 {
    width: 100% !important;
    height: 100% !important;
    min-height: 200px !important;
    max-height: 300px !important;
    object-fit: cover !important;
    object-position: center !important;
    margin: 0 !important;
    padding: 0 !important;
    display: block !important;
    position: relative !important;
    z-index: 1 !important;
  }

  /* block_19 - 在线购墓 */
  .block_19 {
    width: 100% !important;
    padding: 20px 10px !important;
    margin: 20px 0 !important;
  }

  /* 在线购墓模块 - 移动端响应式 */
  .online-purchase-wrapper {
    flex-direction: column !important;
    align-items: center !important;
    gap: 20px !important;
    padding: 0 10px !important;
    overflow: hidden !important;
  }

  .online-purchase-header-left {
    flex: 0 0 100% !important;
    width: 100% !important;
    max-width: 100% !important;
    flex-direction: row !important;
    align-items: center !important;
    justify-content: center !important;
    overflow: hidden !important;
  }

  .online-purchase-header-left .text_69_en,
  .online-purchase-header-left .text_69 {
    font-size: 14px !important;
    writing-mode: initial !important;
    margin: 10px 0 !important;
  }

  .online-purchase-separator {
    height: 40px !important;
    margin: 0 10px !important;
  }

  .online-purchase-content {
    flex: 1 1 auto !important;
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    align-items: center !important;
    overflow: hidden !important;
  }

  .online-purchase-image {
    width: 100% !important;
    max-width: 100% !important;
    height: auto !important;
    object-fit: contain !important;
    box-sizing: border-box !important;
  }

  .online-purchase-content .text-wrapper_5 {
    width: 100% !important;
    max-width: 151px !important;
    margin: 20px auto 0 !important;
  }

  /* block_22 - 人文纪念 */
  .block_22 {
    width: 100% !important;
    padding: 20px 10px !important;
    margin: 20px 0 !important;
  }

  .block_22 .group_30 {
    flex-direction: column !important;
    align-items: center !important;
  }

  .block_22 .text_69 {
    font-size: 24px !important;
  }

  .block_22 .text_70 {
    font-size: 12px !important;
  }

  .block_22 .group_31 {
    flex-wrap: wrap !important;
    justify-content: center !important;
  }

  /* block_8 - 联系我们部分 */
  .block_8 {
    width: 100% !important;
    max-width: 100% !important;
    padding: 20px 10px !important;
    margin-top: 20px !important;
  }

  .box_11 {
    width: 100% !important;
    margin: 20px 0 !important;
    padding: 0 10px !important;
  }

  .box_15 {
    width: 100% !important;
    margin: 20px auto !important;
    text-align: center !important;
  }

  .box_16 {
    width: 100% !important;
    max-width: 100% !important;
    margin: 20px 0 !important;
    padding: 0 10px !important;
    flex-direction: column !important;
    align-items: center !important;
    height: auto !important;
  }

  .text_48 {
    font-size: 32px !important;
    margin: 10px 0 !important;
    text-align: center !important;
  }

  .image_5 {
    width: 100% !important;
    max-width: 100% !important;
    height: auto !important;
    margin: 10px 0 !important;
  }

  .image_7 {
    position: relative !important;
    width: 100% !important;
    max-width: 100% !important;
    height: auto !important;
    top: 0 !important;
    left: 0 !important;
    margin: 20px 0 !important;
  }

  .image-wrapper_2 {
    width: 100% !important;
    margin: 20px 0 !important;
    padding: 0 10px !important;
  }

  .image_6 {
    width: 100% !important;
    height: auto !important;
  }

  .box_17 {
    position: relative !important;
    width: 100% !important;
    max-width: 100% !important;
    left: 0 !important;
    top: 0 !important;
    margin: 20px 0 !important;
    padding: 20px 10px !important;
    background-size: cover !important;
  }

  .text-wrapper_12 {
    width: 100% !important;
    margin: 10px 0 !important;
    text-align: center !important;
  }

  .text_49 {
    font-size: 12px !important;
  }

  .group_27 {
    width: 100% !important;
    flex-direction: column !important;
    align-items: center !important;
    margin: 20px 0 !important;
    padding: 0 10px !important;
  }

  .box_18,
  .box_19,
  .box_20 {
    width: 100% !important;
    max-width: 200px !important;
    margin: 10px 0 !important;
    text-align: center !important;
  }

  /* section_8 - 园林景观部分 */
  .section_8 {
    width: 100% !important;
    padding: 20px 10px !important;
    margin: 20px 0 !important;
  }

  .garden-header {
    flex-direction: column !important;
    align-items: center !important;
    margin: 20px 0 !important;
  }

  .garden-header-left,
  .garden-header-right {
    display: none !important;
  }

  .garden-header-center {
    text-align: center !important;
  }

  .text_67 {
    font-size: 24px !important;
  }

  .text_68 {
    font-size: 12px !important;
  }

  .garden-list-wrapper {
    flex-direction: column !important;
    align-items: center !important;
  }

  .garden-list-wrapper .block_14 {
    width: 100% !important;
    max-width: 280px !important;
    height: calc(100vw * 0.8 * 1.423) !important; /* 保持宽高比，基于容器宽度 */
    max-height: 398px !important; /* 280 * 1.423 ≈ 398 */
    min-width: 200px !important;
    min-height: 284px !important; /* 200 * 1.423 ≈ 284 */
    margin: 10px auto !important;
  }

  /* 确保内部元素按比例缩放 */
  .garden-list-wrapper .block_14 .image-text_1 {
    width: 100% !important;
    height: calc(100% - 16px) !important;
  }

  .garden-list-wrapper .block_14 .box_30 {
    width: 100% !important;
    height: calc(100% - 32px) !important;
  }

  /* 确保文字居中 */
  .garden-list-wrapper .block_14 .text-group_2 {
    width: 100% !important;
    margin: 8px 0 0 0 !important;
    text-align: center !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
  }

  /* block_5 - 墓型展示部分 */
  .block_5 {
    width: 100% !important;
    padding: 20px 10px !important;
    margin: 20px 0 !important;
  }

  .box_1 {
    flex-direction: column !important;
    align-items: center !important;
    margin: 10px 0 !important;
   
  }

  .text_12,
  .text_13,
  .text_14,
  .text_15,
  .text_16 {
    font-size: 12px !important;
    margin: 5px 0 !important;
    text-align: center !important;
    width: 50% !important;
  }

  .box_2 {
    flex-wrap: wrap !important;
    justify-content: center !important;
    gap: 10px !important;
    margin: 20px 0 !important;
  }

  .group_12,
  .group_13,
  .group_15,
  .group_17 {
    width: calc(50% - 5px) !important;
    margin: 5px !important;
  }

  .text_17,
  .text_18,
  .text_19,
  .text_20 {
    font-size: 14px !important;
  }

  .box_3,
  .box_4 {
    width: 100% !important;
    margin: 20px 0 !important;
    text-align: center !important;
  }

  .text-wrapper_6 {
    width: 100% !important;
    text-align: center !important;
    margin: 20px 0 !important;
  }

  .box_5,
  .box_6,
  .box_8,
  .box_9 {
    width: calc(50% - 5px) !important;
    margin: 5px !important;
  }

  .text_25,
  .text_26,
  .text_27,
  .text_28 {
    font-size: 12px !important;
  }

  /* 新闻资讯部分 */
  .news-header-row-1 {
    flex-direction: column !important;
    gap: 20px !important;
    padding: 0 10px !important;
  }

  .news-header-left {
    flex: 0 0 100% !important;
    width: 100% !important;
    align-items: center !important;
  }

  .news-list-wrapper {
    flex: 0 0 100% !important;
    width: 100% !important;
    flex-direction: column !important;
  }

  .news-list-column {
    flex: 0 0 100% !important;
    width: 100% !important;
  }

  .text_29,
  .text_30 {
    font-size: 14px !important;
    margin: 10px 0 !important;
    writing-mode: initial !important;
    text-orientation: initial !important;
  }

  .section_1 {
    width: 100% !important;
    margin: 20px 0 !important;
  }

  .group_28 {
    position: relative !important;
    width: 100% !important;
    max-width: 100% !important;
    left: 0 !important;
    top: 0 !important;
    margin: 20px 0 !important;
    padding: 20px 10px !important;
    background-size: cover !important;
  }

  .box_21 {
    width: 100% !important;
    flex-wrap: wrap !important;
    justify-content: center !important;
    margin: 10px 0 !important;
  }

  .text_53,
  .text_54,
  .text_55,
  .text_56,
  .text_57,
  .text_58,
  .text_59,
  .text_60 {
    font-size: 12px !important;
    margin: 5px !important;
  }

  .text-wrapper_13 {
    width: 100% !important;
    padding: 0 10px !important;
    margin: 10px 0 !important;
  }

  .text_61 {
    font-size: 10px !important;
    line-height: 1.5 !important;
    text-align: center !important;
  }
}


/* ==================================
   Section 3: Landscape (园林景观)
   ================================== */
.section-landscape {
  margin-bottom: 60px;
}

.section-header {
  text-align: center;
  margin-bottom: 40px;
}

.header-main {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-bottom: 10px;
}

.header-deco {
  width: 300px;
  height: auto;
}

.header-title {
  font-family: STKaitiSC-Black;
  font-size: 32px;
  color: #333;
  margin: 0;
}

.header-sub {
  font-family: Arial;
  font-size: 14px;
  color: #999;
  letter-spacing: 2px;
}

.landscape-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 30px;
}

.landscape-card {
  display: flex;
  flex-direction: column;
  background: #f9f9f9;
  transition: transform 0.3s ease;
}

.landscape-card:hover {
  transform: translateY(-5px);
}

.card-image-box {
  width: 100%;
  aspect-ratio: 4/3;
  overflow: hidden;
}

.card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.card-title {
  padding: 15px;
  text-align: center;
  font-size: 16px;
  color: #5c5c5c;
  font-family: STKaitiSC-Regular;
  background-color: #fff;
  border-top: 1px solid #eee;
}

.section-footer {
  text-align: center;
}

.expand-btn {
  width: 170px;
  margin: 0 auto;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.expand-btn.rotated {
  transform: rotate(180deg);
}

/* Mobile Adaptation for Landscape */
@media (max-width: 992px) {
  .landscape-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 480px) {
  .header-title {
    font-size: 24px;
  }
  
  .header-deco {
    width: 30px;
  }

  .landscape-grid {
    grid-template-columns: repeat(1, 1fr);
  }
}

/* ==================================
   Section 4: Tomb Display (墓型展示)
   ================================== */
.section-tomb {
  margin-bottom: 60px;
}

.tomb-intro {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 30px;
  margin-bottom: 40px;
  text-align: left;
}

.intro-card-img img {
  width: 200px;
  height: auto;
}

.intro-card-text h3 {
  font-size: 18px;
  color: #8c3000;
  margin-bottom: 10px;
  font-family: STKaitiSC-Black;
}

.intro-card-text p {
  font-size: 12px;
  color: #999;
  max-width: 300px;
}

.tomb-tabs {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-bottom: 30px;
  flex-wrap: wrap;
}

.tab-item {
  padding: 15px 54px;
  /* border-radius: 20px; */
  /* border: 1px solid #ddd; */
  cursor: pointer;
  background: #fff;
  color: #666;
  font-size: 14px;
  transition: all 0.3s;
}

.tab-item:hover, .tab-item.active {
  background: #8c3000;
  color: #fff;
  border-color: #8c3000;
  background: url(./assets/img/fc0ff83b99b2e317a75517a82ff681a3.png) 100% no-repeat !important;
  background-size: 100% 100% !important;
}

.tomb-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-bottom: 40px;
}

.tomb-card {
  background: #fff;
  transition: transform 0.3s ease;
}

.tomb-card:hover {
  transform: translateY(-5px);
}

.tomb-img-box {
  width: 100%;
  aspect-ratio: 1;
  overflow: hidden;
  border-radius: 4px;
  margin-bottom: 10px;
}

.tomb-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.tomb-title {
  text-align: center;
  font-size: 14px;
  color: #333;
}

.view-all-btn {
  display: inline-block;
  padding: 10px 40px;
  border: 1px solid #8c3000;
  color: #8c3000;
  border-radius: 20px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
}

.view-all-btn:hover {
  background: #8c3000;
  color: #fff;
}

/* Mobile Adaptation for Tomb */
@media (max-width: 992px) {
  .tomb-grid {
    grid-template-columns: repeat(3, 1fr);
  }
  .header-deco {
  width: 50px ;
  height: auto;
}
}

@media (max-width: 768px) {
  .tomb-intro {
    flex-direction: column;
    text-align: center;
    gap: 10px;
  }
  
  .intro-card-text p {
    margin: 0 auto;
  }

  .tomb-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 480px) {
  .tomb-grid {
    grid-template-columns: repeat(2, 1fr); 
    gap: 10px;
  }
  
  .tab-item {
    padding: 6px 16px;
    font-size: 12px;
  }
}

/* ==================================
   Section 5: Online Purchase (在线购墓)
   ================================== */
.section-online-purchase {
  margin-bottom: 60px;
}

.online-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff; /* kept simple white background */
  padding: 0;
}

.online-left {
  display: flex;
  /* flex-direction: column; */
  /* flex: 1; */
  align-items: center;
}

.online-en {
  font-size: 30px;
  color: #999;
  letter-spacing: 2px;
      writing-mode: vertical-rl;
    text-orientation: mixed ;
    letter-spacing: 3px ;
    color: rgba(92, 92, 92, 1) !important
}

.online-sep {
  width: 2px;
  height: 40px;
  background: #8c3000;
  margin: 10px 22px;
   writing-mode: vertical-rl;
    text-orientation: mixed ;
    letter-spacing: 3px ;
}

.online-cn {
  font-size: 40px;
  color: #333;
  font-family: STKaitiSC-Black;
  font-weight: 500;
   writing-mode: vertical-rl;
    text-orientation: mixed ;
    letter-spacing: 3px ;
    color: rgba(0, 0, 0, 1) !important;
    font-size: 40px !important;
    font-family: KaiTi, 楷体, STKaiti, STKaitiSC-Regular !important;
    font-weight: normal !important;
}

.online-right {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  flex: 1;
  text-align: right; /* Align right side */
}

.online-img {
  width: 100%;
  /* max-width: 450px; */
  height: auto;
  border-radius: 4px;
}

.online-btn {
    width: 194px !important;
    height: 62px !important;
  padding: 12px 60px;
  /* background: #8c3000; */
  /* color: #fff; */
  /* border-radius: 30px; */
  cursor: pointer;
  font-size: 18px;
  transition: background 0.3s;
  text-align: center;
  margin-top: 20px;
   background: url(/files/images/goumu.jpg) 100% no-repeat !important; /* 使用 goumu.jpg 作为背景图片 */
  background-size: 100% 100%;
}

.online-btn:hover {
  background: #a04000;
}

@media (max-width: 992px) {
  .online-card {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 30px;
  }
  
  .online-left {
    align-items: center;
     display: flex;
  flex-direction: column;
  }
  
  .online-right {
    width: 100%;
  }
  
  .online-img {
    width: 100%;
    max-width: 100%;
  }
}

/* ==================================
   Section 6: Memorial (人文纪念)
   ================================== */
.section-memorial {
  margin-bottom: 60px;
  background-color: rgba(68, 76, 79, 1) !important;
  margin: 0;
  width: 100% !important;
}

.memorial-content-wrapper {
  display: flex;
  /* gap: 30px; */
 
  width: 70%;
  margin: 0 auto;
  padding-top: 100px;
  padding-bottom: 100px;
  box-sizing: border-box;
}

.mem-left {
  /* flex: 3; */
  width: 60%;
  display: flex;
  flex-direction: column;
}

.mem-header {
  margin-bottom: 30px;
}

.mem-cn {
  font-size: 24px;
  color: #333;
  font-family: STKaitiSC-Black;
}

.mem-sep {
  width: 40px;
  height: 2px;
  background: #8c3000;
  margin: 10px 0;
}

.mem-en {
  font-size: 14px;
  color: #999;
  letter-spacing: 1px;
}

.mem-body {
  display: flex;
  /* gap: 20px; */
}

.mem-img-small {
  /* width: 50%; */
  width:300px;
  height: auto;
  /* object-fit: cover; */
  border-radius: 4px;
}

.mem-info {
  /* flex: 1; */
    width: 65%;
  height: 900px;
  background: url(./assets/img/fd18f32fed6d241dbd9ae9e78013def1.png)
    100% no-repeat;
  background-size: 100% 100%;
  text-align: center;
}

.mem-sub-cn {
  font-size: 20px;
  color: #8c3000;
  margin-bottom: 5px;
  font-family: STKaitiSC-Black;
  font-size: clamp(24px, 3vw, 32px) !important;
}

.mem-sub-en {
  font-size: 12px;
  color: #999;
      overflow-wrap: break-word !important;
    color: rgba(140, 48, 0, 1) !important;
    font-size: clamp(12px, 1.2vw, 16px) !important;
    font-family: BookmanOldStyle !important;
    font-weight: normal !important;
    text-align: center !important;
    white-space: nowrap !important;
    line-height: 16px !important;
    /* margin: 22px 0 0 70px !important; */
}

.mem-sub-sep {
  width: 30px;
  height: 2px;
  background: #ccc;
  margin: 15px 0;
}

.mem-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.8;
  margin-bottom: 20px;
}

.mem-arrow-btn {
  width: 169px;
  cursor: pointer;
  transition: transform 0.3s;
}

.mem-arrow-btn:hover {
  transform: translateX(5px);
}

.mem-right {
  width: 45%;
  /* flex: 4; */
}

.mem-img-large {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
  min-height: 400px;
}

@media (max-width: 992px) {
  .memorial-content-wrapper {
    flex-direction: column;
    padding-top: 60px;
    padding-bottom: 60px;
  }
  
  .mem-body {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  
  .mem-header {
    text-align: center;
  }
  
  .mem-sep {
    margin: 10px auto;
  }
  
  .mem-right {
    width: 100%;
  }
  .mem-img-small {
  
  height: auto;
  object-fit: cover;
  border-radius: 4px;
}
.mem-info {
  /* flex: 1; */
    width: 100%;
  height: auto;
  background: url(./assets/img/fd18f32fed6d241dbd9ae9e78013def1.png)
    100% no-repeat;
  background-size: 100% 100%;
  text-align: center;
}
.mem-body{
  width: 100% !important;
}
.mem-left{
  width: 100% !important;
}
}

/* ==================================
   Section 7: News (新闻资讯)
   ================================== */
.section-news {
  margin-bottom: 60px;
}

.news-layout {
  display: flex;
  gap: 40px;
}

.news-header {
  flex: 1;
  text-align: right;
  padding-top: 20px;
}

.news-header-en {
  writing-mode: vertical-rl;
  text-orientation: mixed;
  font-size: 14px;
  color: #666;
  float: right;
  margin-left: 10px;
}

.news-header-sep {
  width: 2px;
  height: 60px;
  background: #8c3000;
  float: right;
  margin: 0 10px;
}

.news-header-cn {
  writing-mode: vertical-rl;
  text-orientation: mixed;
  font-size: 28px;
  color: #333;
  font-family: STKaitiSC-Black;
  float: right;
}

.news-grid-wrapper {
  flex: 3;
  display: flex;
  gap: 20px;
  
}

.news-column {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
  width:550px;
}

.news-card {
  display: flex;
  gap: 15px;
  padding: 15px;
  background: #fafafa;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.3s;
}

.news-card:hover {
  background: #eee;
}

.news-date-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 60px;
  flex-shrink: 0;
  border-right: 1px solid #ddd;
  padding-right: 15px;
}

.news-day {
  font-size: 24px;
  color: #8c3000;
  font-weight: bold;
}

.news-date-sep {
  width: 20px;
  height: 2px;
  background: #ddd;
  margin: 5px 0;
}

.news-month {
  font-size: 12px;
  color: #999;
}

.news-content {
  flex: 1;
  overflow: hidden;
}

.news-title {
  font-size: 16px;
  color: #333;
  font-weight: bold;
  margin-bottom: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.news-desc {
  font-size: 12px;
  color: #666;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

@media (max-width: 992px) {
  .online-sep {
  width: 40px;
  height: 2px;
  background: #8c3000;
  margin: 10px 0;
   writing-mode: vertical-rl;
    text-orientation: mixed ;
    letter-spacing: 3px ;
}
.news-column {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
  width:300px;
}
  .online-en ,.online-sep, .online-cn{
  font-size: 14px;
  color: #999;
  letter-spacing: 2px;
  writing-mode: horizontal-tb !important;
  /* 覆盖 text-orientation 为默认值 */
  text-orientation: upright !important;
  /* 覆盖 letter-spacing 为默认值 0 */
  letter-spacing: 0 !important;
}
  .news-layout {
    flex-direction: column;
  }
  
  .news-header {
    text-align: center;
    padding-top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .news-header-en, .news-header-cn {
    writing-mode: horizontal-tb;
    float: none;
    margin: 0 10px;
  }
  
  .news-header-sep {
    width: 40px;
    height: 2px;
    float: none;
    display: none;
  }
  
  .news-grid-wrapper {
    flex-direction: column;
  }
  .footer-phone-icon{
    position: relative;
  }
  .footer-phone-img{
    position: absolute;
    top:15px;
    left:18px !important
  }
}
</style>

